import _asyncToGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _awaitAsyncGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import $7dfcac1a0c98c789$exports from "./ar-AE.module.js";
import $f311c26671219eca$exports from "./bg-BG.module.js";
import $1aa4ade186550f72$exports from "./cs-CZ.module.js";
import $b6b0ea1b94a7633c$exports from "./da-DK.module.js";
import $d10e4f47c744ad52$exports from "./de-DE.module.js";
import $b3d2bb9abce688ab$exports from "./el-GR.module.js";
import $f9b46437e610cca1$exports from "./en-US.module.js";
import $204b5c01bd3acf26$exports from "./es-ES.module.js";
import $110bdd83348ecbc0$exports from "./et-EE.module.js";
import $87d3ccd5e347c7cc$exports from "./fi-FI.module.js";
import $a5de891427686596$exports from "./fr-FR.module.js";
import $ad7f4c66d85b4494$exports from "./he-IL.module.js";
import $4aa59f3c6a796cae$exports from "./hr-HR.module.js";
import $d8d3646556c40586$exports from "./hu-HU.module.js";
import $982d558b45395246$exports from "./it-IT.module.js";
import $6a0cf387b9de036c$exports from "./ja-JP.module.js";
import $a97fefa2956f4bcb$exports from "./ko-KR.module.js";
import $5fb5837f94e1c150$exports from "./lt-LT.module.js";
import $5b2e5709864cc922$exports from "./lv-LV.module.js";
import $ee15bb8efb18cc69$exports from "./nb-NO.module.js";
import $1daf2d4602e26ac4$exports from "./nl-NL.module.js";
import $7115429b0f60511f$exports from "./pl-PL.module.js";
import $5edd453ae5d4a8bc$exports from "./pt-BR.module.js";
import $5f431994f708535e$exports from "./pt-PT.module.js";
import $107b5e2e45e971f1$exports from "./ro-RO.module.js";
import $d4b9c2f01c1892f7$exports from "./ru-RU.module.js";
import $dbdc1942894e83e4$exports from "./sk-SK.module.js";
import $fbaaaaebd547d998$exports from "./sl-SI.module.js";
import $a0caa33f1e264489$exports from "./sr-SP.module.js";
import $d576b66176f5c0ff$exports from "./sv-SE.module.js";
import $0681f168c13d8f2a$exports from "./tr-TR.module.js";
import $2bfbc1f42c1cf5a7$exports from "./uk-UA.module.js";
import $d0f488d433b55b8a$exports from "./zh-CN.module.js";
import $46168b0dce85301e$exports from "./zh-TW.module.js";
import { useInteractionModality as $fP8tg$useInteractionModality, getInteractionModality as $fP8tg$getInteractionModality, setInteractionModality as $fP8tg$setInteractionModality, useFocus as $fP8tg$useFocus } from "@react-aria/interactions";
import $fP8tg$react, { useRef as $fP8tg$useRef, useState as $fP8tg$useState, useEffect as $fP8tg$useEffect, useCallback as $fP8tg$useCallback, useImperativeHandle as $fP8tg$useImperativeHandle } from "react";
import { useGlobalListeners as $fP8tg$useGlobalListeners, useLayoutEffect as $fP8tg$useLayoutEffect, useDescription as $fP8tg$useDescription, isVirtualPointerEvent as $fP8tg$isVirtualPointerEvent, isVirtualClick as $fP8tg$isVirtualClick, useEffectEvent as $fP8tg$useEffectEvent, isMac as $fP8tg$isMac, isIPad as $fP8tg$isIPad, useId as $fP8tg$useId, mergeProps as $fP8tg$mergeProps, isScrollable as $fP8tg$isScrollable, getScrollParent as $fP8tg$getScrollParent, isWebKit as $fP8tg$isWebKit, isIOS as $fP8tg$isIOS, chain as $fP8tg$chain } from "@react-aria/utils";
import { useLocalizedStringFormatter as $fP8tg$useLocalizedStringFormatter, useLocale as $fP8tg$useLocale } from "@react-aria/i18n";
import { announce as $fP8tg$announce } from "@react-aria/live-announcer";
import { ariaHideOutside as $fP8tg$ariaHideOutside } from "@react-aria/overlays";
import { flushSync as $fP8tg$flushSync } from "react-dom";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */ /*
       * Copyright 2020 Adobe. All rights reserved.
       * This file is licensed to you under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License. You may obtain a copy
       * of the License at http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software distributed under
       * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
       * OF ANY KIND, either express or implied. See the License for the specific language
       * governing permissions and limitations under the License.
       */
var $103790afe9474d1c$export$60b7b4bcf3903d8e;
(function (DROP_OPERATION) {
  DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
  DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
  DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
  DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
  DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
  DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
})($103790afe9474d1c$export$60b7b4bcf3903d8e || ($103790afe9474d1c$export$60b7b4bcf3903d8e = {}));
var $103790afe9474d1c$export$9bbdfc78cf083e16 = _objectSpread({}, $103790afe9474d1c$export$60b7b4bcf3903d8e, {
  copyMove: 3,
  copyLink: 6,
  linkMove: 5,
  all: 7,
  uninitialized: 7
});
var $103790afe9474d1c$export$dd0165308d8bff45 = $103790afe9474d1c$var$invert($103790afe9474d1c$export$9bbdfc78cf083e16);
$103790afe9474d1c$export$dd0165308d8bff45[7] = "all"; // ensure we don't map to 'uninitialized'.
var $103790afe9474d1c$export$d7ebf00f36b7a95e = $103790afe9474d1c$var$invert($103790afe9474d1c$export$60b7b4bcf3903d8e);
var $103790afe9474d1c$export$608ecc6f1b23c35d = {
  none: "cancel",
  link: "link",
  copy: "copy",
  move: "move"
};
var $103790afe9474d1c$export$5eacb0769d26d3b2 = $103790afe9474d1c$var$invert($103790afe9474d1c$export$608ecc6f1b23c35d);
function $103790afe9474d1c$var$invert(object) {
  var res = {};
  for (var key in object) {
    res[object[key]] = key;
  }
  return res;
}
var $103790afe9474d1c$export$4a7729b856e9a690 = new Set(["text/plain", "text/uri-list", "text/html"]);
var $103790afe9474d1c$export$fd9f9fc120c5402d = "application/vnd.react-aria.items+json";
var $103790afe9474d1c$export$f8fc6581787339b3 = "application/octet-stream";
var $7252cd45fc48c07c$export$dfdf5deeaf27473f = new WeakMap();
var $7252cd45fc48c07c$export$990fced5dfac2637 = Symbol();
function $7252cd45fc48c07c$export$3093291712f09a77(state) {
  var _$7252cd45fc48c07c$ex = $7252cd45fc48c07c$export$dfdf5deeaf27473f.get(state),
    id = _$7252cd45fc48c07c$ex.id;
  if (!id) throw new Error("Droppable item outside a droppable collection");
  return id;
}
function $7252cd45fc48c07c$export$7e397efd01d3db27(state) {
  var _$7252cd45fc48c07c$ex2 = $7252cd45fc48c07c$export$dfdf5deeaf27473f.get(state),
    ref = _$7252cd45fc48c07c$ex2.ref;
  if (!ref) throw new Error("Droppable item outside a droppable collection");
  return ref;
}
function $7252cd45fc48c07c$export$e1d41611756c6326(items) {
  var types = new Set();
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      for (var _i = 0, _Object$keys = Object.keys(item); _i < _Object$keys.length; _i++) {
        var type = _Object$keys[_i];
        types.add(type);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return types;
}
function $7252cd45fc48c07c$var$mapModality(modality) {
  if (!modality) modality = "virtual";
  if (modality === "pointer") modality = "virtual";
  if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "touch";
  return modality;
}
function $7252cd45fc48c07c$export$49bac5d6d4b352ea() {
  return $7252cd45fc48c07c$var$mapModality((0, $fP8tg$useInteractionModality)());
}
function $7252cd45fc48c07c$export$1fb2158d224b542c() {
  return $7252cd45fc48c07c$var$mapModality((0, $fP8tg$getInteractionModality)());
}
function $7252cd45fc48c07c$export$f9c1490890ddd063(dataTransfer, items) {
  // The data transfer API doesn't support more than one item of a given type at once.
  // In addition, only a small set of types are supported natively for transfer between applications.
  // We allow for both multiple items, as well as multiple representations of a single item.
  // In order to make our API work with the native API, we serialize all items to JSON and
  // store as a single native item. We only need to do this if there is more than one item
  // of the same type, or if an item has more than one representation. Otherwise the native
  // API is sufficient.
  //
  // The DataTransferItemList API also theoretically supports adding files, which would enable
  // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
  // this does not currently work in any browser, so it is not currently supported by our API.
  // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
  var groupedByType = new Map();
  var needsCustomData = false;
  var customData = [];
  var _iterator2 = _createForOfIteratorHelper(items),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var types = Object.keys(item);
      if (types.length > 1) needsCustomData = true;
      var dataByType = {};
      for (var _i2 = 0, _types = types; _i2 < _types.length; _i2++) {
        var type = _types[_i2];
        var typeItems = groupedByType.get(type);
        if (!typeItems) {
          typeItems = [];
          groupedByType.set(type, typeItems);
        } else needsCustomData = true;
        var _data = item[type];
        dataByType[type] = _data;
        typeItems.push(_data);
      }
      customData.push(dataByType);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(groupedByType),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        _type = _step3$value[0],
        _items = _step3$value[1];
      if ((0, $103790afe9474d1c$export$4a7729b856e9a690).has(_type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        var _data2 = _items.join("\n");
        dataTransfer.items.add(_data2, _type);
      } else
        // Set data to the first item so we have access to the list of types.
        dataTransfer.items.add(_items[0], _type);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (needsCustomData) {
    var data = JSON.stringify(customData);
    dataTransfer.items.add(data, (0, $103790afe9474d1c$export$fd9f9fc120c5402d));
  }
}
var $7252cd45fc48c07c$export$7f04ce188c91447c = /*#__PURE__*/function () {
  _createClass($7252cd45fc48c07c$export$7f04ce188c91447c, [{
    key: "has",
    value: function has(type) {
      if (this.includesUnknownTypes || type === $7252cd45fc48c07c$export$990fced5dfac2637 && this.types.has((0, $103790afe9474d1c$export$f8fc6581787339b3))) return true;
      return typeof type === "string" && this.types.has(type);
    }
  }]);
  function $7252cd45fc48c07c$export$7f04ce188c91447c(dataTransfer) {
    _classCallCheck(this, $7252cd45fc48c07c$export$7f04ce188c91447c);
    this.types = new Set();
    var hasFiles = false;
    var _iterator4 = _createForOfIteratorHelper(dataTransfer.items),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var item = _step4.value;
        if (item.type !== (0, $103790afe9474d1c$export$fd9f9fc120c5402d)) {
          if (item.kind === "file") hasFiles = true;
          if (item.type) this.types.add(item.type);else
            // Files with unknown types or extensions that don't map to a known mime type
            // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, $103790afe9474d1c$export$f8fc6581787339b3));
        }
      }
      // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
      // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
      // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes("Files");
  }
  return $7252cd45fc48c07c$export$7f04ce188c91447c;
}();
function $7252cd45fc48c07c$export$d9e760437831f8b3(dataTransfer) {
  var items = [];
  // If our custom drag type is available, use that. This is a JSON serialized
  // representation of all items in the drag, set when there are multiple items
  // of the same type, or an individual item has multiple representations.
  var hasCustomType = false;
  if (dataTransfer.types.includes((0, $103790afe9474d1c$export$fd9f9fc120c5402d))) try {
    var data = dataTransfer.getData((0, $103790afe9474d1c$export$fd9f9fc120c5402d));
    var parsed = JSON.parse(data);
    var _iterator5 = _createForOfIteratorHelper(parsed),
      _step5;
    try {
      var _loop = function _loop() {
        var item = _step5.value;
        items.push({
          kind: "text",
          types: new Set(Object.keys(item)),
          getText: function getText(type) {
            return Promise.resolve(item[type]);
          }
        });
      };
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    hasCustomType = true;
  } catch (e) {
    // ignore
  }
  // Otherwise, map native drag items to items of a single representation.
  if (!hasCustomType) {
    var stringItems = new Map();
    var _iterator6 = _createForOfIteratorHelper(dataTransfer.items),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var item = _step6.value;
        if (item.kind === "string")
          // The data for all formats must be read here because the data transfer gets
          // cleared out after the event handler finishes. If the item has an empty string
          // as a type, the mime type is unknown. Map to a generic mime type instead.
          stringItems.set(item.type || (0, $103790afe9474d1c$export$f8fc6581787339b3), dataTransfer.getData(item.type));else if (item.kind === "file") {
          // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
          // In the future, we may use getAsFileSystemHandle instead, but that's currently
          // only implemented in Chrome.
          if (typeof item.webkitGetAsEntry === "function") {
            var entry = item.webkitGetAsEntry();
            // eslint-disable-next-line max-depth
            if (!entry) continue;
            // eslint-disable-next-line max-depth
            if (entry.isFile) items.push($7252cd45fc48c07c$var$createFileItem(item.getAsFile()));else if (entry.isDirectory) items.push($7252cd45fc48c07c$var$createDirectoryItem(entry));
          } else
            // Assume it's a file.
            items.push($7252cd45fc48c07c$var$createFileItem(item.getAsFile()));
        }
      }
      // All string items are different representations of the same item. There's no way to have
      // multiple string items at once in the current DataTransfer API.
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    if (stringItems.size > 0) items.push({
      kind: "text",
      types: new Set(stringItems.keys()),
      getText: function getText(type) {
        return Promise.resolve(stringItems.get(type));
      }
    });
  }
  return items;
}
function $7252cd45fc48c07c$var$blobToString(blob) {
  if (typeof blob.text === "function") return blob.text();
  // Safari doesn't have the Blob#text() method yet...
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsText(blob);
  });
}
function $7252cd45fc48c07c$var$createFileItem(file) {
  return {
    kind: "file",
    type: file.type || (0, $103790afe9474d1c$export$f8fc6581787339b3),
    name: file.name,
    getText: function getText() {
      return $7252cd45fc48c07c$var$blobToString(file);
    },
    getFile: function getFile() {
      return Promise.resolve(file);
    }
  };
}
function $7252cd45fc48c07c$var$createDirectoryItem(entry) {
  return {
    kind: "directory",
    name: entry.name,
    getEntries: function getEntries() {
      return $7252cd45fc48c07c$var$getEntries(entry);
    }
  };
}
function $7252cd45fc48c07c$var$getEntries(_x) {
  return _$7252cd45fc48c07c$var$getEntries.apply(this, arguments);
}
function _$7252cd45fc48c07c$var$getEntries() {
  _$7252cd45fc48c07c$var$getEntries = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
    var reader, entries, _iterator7, _step7, entry, file;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = item.createReader(); // We must call readEntries repeatedly because there may be a limit to the
            // number of entries that are returned at once.
          case 1:
            _context.next = 3;
            return _awaitAsyncGenerator(new Promise(function (resolve, reject) {
              reader.readEntries(resolve, reject);
            }));
          case 3:
            entries = _context.sent;
            _iterator7 = _createForOfIteratorHelper(entries);
            _context.prev = 5;
            _iterator7.s();
          case 7:
            if ((_step7 = _iterator7.n()).done) {
              _context.next = 22;
              break;
            }
            entry = _step7.value;
            if (!entry.isFile) {
              _context.next = 17;
              break;
            }
            _context.next = 12;
            return _awaitAsyncGenerator($7252cd45fc48c07c$var$getEntryFile(entry));
          case 12:
            file = _context.sent;
            _context.next = 15;
            return $7252cd45fc48c07c$var$createFileItem(file);
          case 15:
            _context.next = 20;
            break;
          case 17:
            if (!entry.isDirectory) {
              _context.next = 20;
              break;
            }
            _context.next = 20;
            return $7252cd45fc48c07c$var$createDirectoryItem(entry);
          case 20:
            _context.next = 7;
            break;
          case 22:
            _context.next = 27;
            break;
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](5);
            _iterator7.e(_context.t0);
          case 27:
            _context.prev = 27;
            _iterator7.f();
            return _context.finish(27);
          case 30:
            if (entries.length > 0) {
              _context.next = 1;
              break;
            }
          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 24, 27, 30]]);
  }));
  return _$7252cd45fc48c07c$var$getEntries.apply(this, arguments);
}
function $7252cd45fc48c07c$var$getEntryFile(entry) {
  return new Promise(function (resolve, reject) {
    return entry.file(resolve, reject);
  });
}
function $7252cd45fc48c07c$export$97fd558bdc44bea1(dropItem) {
  return dropItem.kind === "text";
}
function $7252cd45fc48c07c$export$a144e1752ebe0aa(dropItem) {
  return dropItem.kind === "file";
}
function $7252cd45fc48c07c$export$2b40a62bdbe6b2b0(dropItem) {
  return dropItem.kind === "directory";
}
var $7252cd45fc48c07c$export$6ca6700462636d0b = {
  draggingKeys: new Set()
};
function $7252cd45fc48c07c$export$f2be18a910c0caa6(ref) {
  $7252cd45fc48c07c$export$6ca6700462636d0b.draggingCollectionRef = ref;
}
function $7252cd45fc48c07c$export$72cb63bdda528276(keys) {
  $7252cd45fc48c07c$export$6ca6700462636d0b.draggingKeys = keys;
}
function $7252cd45fc48c07c$export$dac8db29d42db9a1(ref) {
  $7252cd45fc48c07c$export$6ca6700462636d0b.dropCollectionRef = ref;
}
function $7252cd45fc48c07c$export$70936501603e6c57() {
  $7252cd45fc48c07c$export$6ca6700462636d0b = {
    draggingKeys: new Set()
  };
}
function $7252cd45fc48c07c$export$6c10d32b362bfa5f(state) {
  $7252cd45fc48c07c$export$6ca6700462636d0b = state;
}
function $7252cd45fc48c07c$export$78bf638634500fa5(ref) {
  var _$7252cd45fc48c07c$ex3 = $7252cd45fc48c07c$export$6ca6700462636d0b,
    draggingCollectionRef = _$7252cd45fc48c07c$ex3.draggingCollectionRef,
    dropCollectionRef = _$7252cd45fc48c07c$ex3.dropCollectionRef;
  return (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) != null && draggingCollectionRef.current === ((ref === null || ref === void 0 ? void 0 : ref.current) || (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current));
}
var $7252cd45fc48c07c$export$8e6636520ac15722;
function $7252cd45fc48c07c$export$64f52ed7349ddb84(dropEffect) {
  $7252cd45fc48c07c$export$8e6636520ac15722 = dropEffect;
}
var $7252cd45fc48c07c$export$f0130eb70b6347b8 = (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).none;
function $7252cd45fc48c07c$export$6539bc8c3a0a2d67(o) {
  $7252cd45fc48c07c$export$f0130eb70b6347b8 = o;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $67560de7c78cb232$var$dropTargets = new Map();
var $67560de7c78cb232$var$dropItems = new Map();
var $67560de7c78cb232$var$dragSession = null;
var $67560de7c78cb232$var$subscriptions = new Set();
function $67560de7c78cb232$export$c28d9fb4a54e471a(target) {
  $67560de7c78cb232$var$dropTargets.set(target.element, target);
  $67560de7c78cb232$var$dragSession === null || $67560de7c78cb232$var$dragSession === void 0 ? void 0 : $67560de7c78cb232$var$dragSession.updateValidDropTargets();
  return function () {
    $67560de7c78cb232$var$dropTargets.delete(target.element);
    $67560de7c78cb232$var$dragSession === null || $67560de7c78cb232$var$dragSession === void 0 ? void 0 : $67560de7c78cb232$var$dragSession.updateValidDropTargets();
  };
}
function $67560de7c78cb232$export$aef80212ac99c003(item) {
  $67560de7c78cb232$var$dropItems.set(item.element, item);
  return function () {
    $67560de7c78cb232$var$dropItems.delete(item.element);
  };
}
function $67560de7c78cb232$export$549dbcf8649bf3b2(target, stringFormatter) {
  if ($67560de7c78cb232$var$dragSession) throw new Error("Cannot begin dragging while already dragging");
  $67560de7c78cb232$var$dragSession = new $67560de7c78cb232$var$DragSession(target, stringFormatter);
  requestAnimationFrame(function () {
    $67560de7c78cb232$var$dragSession.setup();
    if ((0, $7252cd45fc48c07c$export$1fb2158d224b542c)() === "keyboard") $67560de7c78cb232$var$dragSession.next();
  });
  var _iterator8 = _createForOfIteratorHelper($67560de7c78cb232$var$subscriptions),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var cb = _step8.value;
      cb();
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
}
function $67560de7c78cb232$export$418e185dd3f1b968() {
  var _ref2 = (0, $fP8tg$useState)($67560de7c78cb232$var$dragSession),
    _ref3 = _slicedToArray(_ref2, 2),
    session = _ref3[0],
    setSession = _ref3[1];
  (0, $fP8tg$useEffect)(function () {
    var cb = function cb() {
      return setSession($67560de7c78cb232$var$dragSession);
    };
    $67560de7c78cb232$var$subscriptions.add(cb);
    return function () {
      $67560de7c78cb232$var$subscriptions.delete(cb);
    };
  }, []);
  return session;
}
function $67560de7c78cb232$export$403bc76cbf68cf60() {
  return !!$67560de7c78cb232$var$dragSession;
}
function $67560de7c78cb232$var$endDragging() {
  $67560de7c78cb232$var$dragSession = null;
  var _iterator9 = _createForOfIteratorHelper($67560de7c78cb232$var$subscriptions),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var cb = _step9.value;
      cb();
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
}
function $67560de7c78cb232$export$7454aff2e161f241(element) {
  var _iterator10 = _createForOfIteratorHelper($67560de7c78cb232$var$dropTargets.keys()),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var target = _step10.value;
      if (target.contains(element)) return true;
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  return false;
}
var $67560de7c78cb232$var$CANCELED_EVENTS = ["pointerdown", "pointermove", "pointerenter", "pointerleave", "pointerover", "pointerout", "pointerup", "mousedown", "mousemove", "mouseenter", "mouseleave", "mouseover", "mouseout", "mouseup", "touchstart", "touchmove", "touchend", "focusin", "focusout"];
var $67560de7c78cb232$var$CLICK_EVENTS = ["pointerup", "mouseup", "touchend"];
var $67560de7c78cb232$var$MESSAGES = {
  keyboard: "dragStartedKeyboard",
  touch: "dragStartedTouch",
  virtual: "dragStartedVirtual"
};
var $67560de7c78cb232$var$DragSession = /*#__PURE__*/function () {
  _createClass($67560de7c78cb232$var$DragSession, [{
    key: "setup",
    value: function setup() {
      var _this = this;
      document.addEventListener("keydown", this.onKeyDown, true);
      document.addEventListener("keyup", this.onKeyUp, true);
      window.addEventListener("focus", this.onFocus, true);
      window.addEventListener("blur", this.onBlur, true);
      document.addEventListener("click", this.onClick, true);
      document.addEventListener("pointerdown", this.onPointerDown, true);
      for (var _i3 = 0, _$67560de7c78cb232$va = $67560de7c78cb232$var$CANCELED_EVENTS; _i3 < _$67560de7c78cb232$va.length; _i3++) {
        var event = _$67560de7c78cb232$va[_i3];
        document.addEventListener(event, this.cancelEvent, true);
      }
      this.mutationObserver = new MutationObserver(function () {
        return _this.updateValidDropTargets();
      });
      this.updateValidDropTargets();
      (0, $fP8tg$announce)(this.stringFormatter.format($67560de7c78cb232$var$MESSAGES[(0, $7252cd45fc48c07c$export$1fb2158d224b542c)()]));
    }
  }, {
    key: "teardown",
    value: function teardown() {
      document.removeEventListener("keydown", this.onKeyDown, true);
      document.removeEventListener("keyup", this.onKeyUp, true);
      window.removeEventListener("focus", this.onFocus, true);
      window.removeEventListener("blur", this.onBlur, true);
      document.removeEventListener("click", this.onClick, true);
      document.removeEventListener("pointerdown", this.onPointerDown, true);
      for (var _i4 = 0, _$67560de7c78cb232$va2 = $67560de7c78cb232$var$CANCELED_EVENTS; _i4 < _$67560de7c78cb232$va2.length; _i4++) {
        var event = _$67560de7c78cb232$va2[_i4];
        document.removeEventListener(event, this.cancelEvent, true);
      }
      this.mutationObserver.disconnect();
      this.restoreAriaHidden();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this_currentDropTarget;
      this.cancelEvent(e);
      if (e.key === "Escape") {
        this.cancel();
        return;
      }
      if (e.key === "Tab" && !(e.metaKey || e.altKey || e.ctrlKey)) {
        if (e.shiftKey) this.previous();else this.next();
      }
      if (typeof ((_this_currentDropTarget = this.currentDropTarget) === null || _this_currentDropTarget === void 0 ? void 0 : _this_currentDropTarget.onKeyDown) === "function") this.currentDropTarget.onKeyDown(e, this.dragTarget);
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      this.cancelEvent(e);
      if (e.key === "Enter") {
        if (e.altKey) this.activate();else this.drop();
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      // Prevent focus events, except to the original drag target.
      if (e.target !== this.dragTarget.element) this.cancelEvent(e);
      // Ignore focus events on the window/document (JSDOM). Will be handled in onBlur, below.
      if (!(e.target instanceof HTMLElement) || e.target === this.dragTarget.element) return;
      var dropTarget = this.validDropTargets.find(function (target) {
        return target.element === e.target;
      }) || this.validDropTargets.find(function (target) {
        return target.element.contains(e.target);
      });
      if (!dropTarget) {
        if (this.currentDropTarget) this.currentDropTarget.element.focus();else this.dragTarget.element.focus();
        return;
      }
      var item = $67560de7c78cb232$var$dropItems.get(e.target);
      this.setCurrentDropTarget(dropTarget, item);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      if (e.target !== this.dragTarget.element) this.cancelEvent(e);
      // If nothing is gaining focus, or e.relatedTarget is the window/document (JSDOM),
      // restore focus back to the current drop target if any, or the original drag target.
      if (!e.relatedTarget || !(e.relatedTarget instanceof HTMLElement)) {
        if (this.currentDropTarget) this.currentDropTarget.element.focus();else this.dragTarget.element.focus();
      }
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      this.cancelEvent(e);
      if ((0, $fP8tg$isVirtualClick)(e) || this.isVirtualClick) {
        if (e.target === this.dragTarget.element) {
          this.cancel();
          return;
        }
        var dropTarget = this.validDropTargets.find(function (target) {
          return target.element.contains(e.target);
        });
        if (dropTarget) {
          var item = $67560de7c78cb232$var$dropItems.get(e.target);
          this.setCurrentDropTarget(dropTarget, item);
          this.drop(item);
        }
      }
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(e) {
      // Android Talkback double tap has e.detail = 1 for onClick. Detect the virtual click in onPointerDown before onClick fires
      // so we can properly perform cancel and drop operations.
      this.cancelEvent(e);
      this.isVirtualClick = (0, $fP8tg$isVirtualPointerEvent)(e);
    }
  }, {
    key: "cancelEvent",
    value: function cancelEvent(e) {
      var _this_dragTarget;
      // Allow focusin and focusout on the drag target so focus ring works properly.
      if ((e.type === "focusin" || e.type === "focusout") && e.target === ((_this_dragTarget = this.dragTarget) === null || _this_dragTarget === void 0 ? void 0 : _this_dragTarget.element)) return;
      // Allow default for events that might cancel a click event
      if (!$67560de7c78cb232$var$CLICK_EVENTS.includes(e.type)) e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, {
    key: "updateValidDropTargets",
    value: function updateValidDropTargets() {
      var _this2 = this;
      if (!this.mutationObserver) return;
      this.mutationObserver.disconnect();
      if (this.restoreAriaHidden) this.restoreAriaHidden();
      this.validDropTargets = $67560de7c78cb232$var$findValidDropTargets(this.dragTarget);
      // Shuffle drop target order based on starting drag target.
      if (this.validDropTargets.length > 0) {
        var nearestIndex = this.findNearestDropTarget();
        this.validDropTargets = [].concat(_toConsumableArray(this.validDropTargets.slice(nearestIndex)), _toConsumableArray(this.validDropTargets.slice(0, nearestIndex)));
      }
      if (this.currentDropTarget && !this.validDropTargets.includes(this.currentDropTarget)) this.setCurrentDropTarget(this.validDropTargets[0]);
      // Find valid drop items within collections
      var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(this.dragTarget.items);
      var validDropItems = _toConsumableArray($67560de7c78cb232$var$dropItems.values()).filter(function (item) {
        if (typeof item.getDropOperation === "function") return item.getDropOperation(types, _this2.dragTarget.allowedDropOperations) !== "cancel";
        return true;
      });
      // Filter out drop targets that contain valid items. We don't want to stop hiding elements
      // other than the drop items that exist inside the collection.
      var visibleDropTargets = this.validDropTargets.filter(function (target) {
        return !validDropItems.some(function (item) {
          return target.element.contains(item.element);
        });
      });
      this.restoreAriaHidden = (0, $fP8tg$ariaHideOutside)([this.dragTarget.element].concat(_toConsumableArray(validDropItems.map(function (item) {
        return item.element;
      })), _toConsumableArray(visibleDropTargets.map(function (target) {
        return target.element;
      }))));
      this.mutationObserver.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden"]
      });
    }
  }, {
    key: "next",
    value: function next() {
      if (!this.currentDropTarget) {
        this.setCurrentDropTarget(this.validDropTargets[0]);
        return;
      }
      var index = this.validDropTargets.indexOf(this.currentDropTarget);
      if (index < 0) {
        this.setCurrentDropTarget(this.validDropTargets[0]);
        return;
      }
      // If we've reached the end of the valid drop targets, cycle back to the original drag target.
      // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
      if (index === this.validDropTargets.length - 1) {
        if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
          this.setCurrentDropTarget(null);
          this.dragTarget.element.focus();
        } else this.setCurrentDropTarget(this.validDropTargets[0]);
      } else this.setCurrentDropTarget(this.validDropTargets[index + 1]);
    }
  }, {
    key: "previous",
    value: function previous() {
      if (!this.currentDropTarget) {
        this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
        return;
      }
      var index = this.validDropTargets.indexOf(this.currentDropTarget);
      if (index < 0) {
        this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
        return;
      }
      // If we've reached the start of the valid drop targets, cycle back to the original drag target.
      // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
      if (index === 0) {
        if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
          this.setCurrentDropTarget(null);
          this.dragTarget.element.focus();
        } else this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
      } else this.setCurrentDropTarget(this.validDropTargets[index - 1]);
    }
  }, {
    key: "findNearestDropTarget",
    value: function findNearestDropTarget() {
      var dragTargetRect = this.dragTarget.element.getBoundingClientRect();
      var minDistance = Infinity;
      var nearest = -1;
      for (var i = 0; i < this.validDropTargets.length; i++) {
        var dropTarget = this.validDropTargets[i];
        var rect = dropTarget.element.getBoundingClientRect();
        var dx = rect.left - dragTargetRect.left;
        var dy = rect.top - dragTargetRect.top;
        var dist = dx * dx + dy * dy;
        if (dist < minDistance) {
          minDistance = dist;
          nearest = i;
        }
      }
      return nearest;
    }
  }, {
    key: "setCurrentDropTarget",
    value: function setCurrentDropTarget(dropTarget, item) {
      if (dropTarget !== this.currentDropTarget) {
        if (this.currentDropTarget && typeof this.currentDropTarget.onDropExit === "function") {
          var rect = this.currentDropTarget.element.getBoundingClientRect();
          this.currentDropTarget.onDropExit({
            type: "dropexit",
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2
          });
        }
        this.currentDropTarget = dropTarget;
        if (dropTarget) {
          if (typeof dropTarget.onDropEnter === "function") {
            var _rect = dropTarget.element.getBoundingClientRect();
            dropTarget.onDropEnter({
              type: "dropenter",
              x: _rect.left + _rect.width / 2,
              y: _rect.top + _rect.height / 2
            }, this.dragTarget);
          }
          if (!item) dropTarget === null || dropTarget === void 0 ? void 0 : dropTarget.element.focus();
        }
      }
      if (item !== this.currentDropItem) {
        if (item && typeof this.currentDropTarget.onDropTargetEnter === "function") this.currentDropTarget.onDropTargetEnter(item === null || item === void 0 ? void 0 : item.target);
        item === null || item === void 0 ? void 0 : item.element.focus();
        this.currentDropItem = item;
        // Announce first drop target after drag start announcement finishes.
        // Otherwise, it will never get announced because drag start announcement is assertive.
        if (!this.initialFocused) {
          (0, $fP8tg$announce)(item === null || item === void 0 ? void 0 : item.element.getAttribute("aria-label"), "polite");
          this.initialFocused = true;
        }
      }
    }
  }, {
    key: "end",
    value: function end() {
      var _this3 = this;
      this.teardown();
      $67560de7c78cb232$var$endDragging();
      if (typeof this.dragTarget.onDragEnd === "function") {
        var target = this.currentDropTarget && this.dropOperation !== "cancel" ? this.currentDropTarget : this.dragTarget;
        var rect = target.element.getBoundingClientRect();
        this.dragTarget.onDragEnd({
          type: "dragend",
          x: rect.x + rect.width / 2,
          y: rect.y + rect.height / 2,
          dropOperation: this.dropOperation || "cancel"
        });
      }
      // Blur and re-focus the drop target so that the focus ring appears.
      if (this.currentDropTarget) {
        // Since we cancel all focus events in drag sessions, refire blur to make sure state gets updated so drag target doesn't think it's still focused
        // i.e. When you from one list to another during a drag session, we need the blur to fire on the first list after the drag.
        if (!this.dragTarget.element.contains(this.currentDropTarget.element)) {
          this.dragTarget.element.dispatchEvent(new FocusEvent("blur"));
          this.dragTarget.element.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true
          }));
        }
        // Re-focus the focusedKey upon reorder. This requires a React rerender between blurring and focusing.
        (0, $fP8tg$flushSync)(function () {
          _this3.currentDropTarget.element.blur();
        });
        this.currentDropTarget.element.focus();
      }
      this.setCurrentDropTarget(null);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.setCurrentDropTarget(null);
      this.end();
      if (!this.dragTarget.element.closest('[aria-hidden="true"]')) this.dragTarget.element.focus();
      (0, $fP8tg$announce)(this.stringFormatter.format("dropCanceled"));
    }
  }, {
    key: "drop",
    value: function drop(item) {
      if (!this.currentDropTarget) {
        this.cancel();
        return;
      }
      if (typeof (item === null || item === void 0 ? void 0 : item.getDropOperation) === "function") {
        var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(this.dragTarget.items);
        this.dropOperation = item.getDropOperation(types, this.dragTarget.allowedDropOperations);
      } else if (typeof this.currentDropTarget.getDropOperation === "function") {
        var _types2 = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(this.dragTarget.items);
        this.dropOperation = this.currentDropTarget.getDropOperation(_types2, this.dragTarget.allowedDropOperations);
      } else
        // TODO: show menu ??
        this.dropOperation = this.dragTarget.allowedDropOperations[0];
      if (typeof this.currentDropTarget.onDrop === "function") {
        var items = this.dragTarget.items.map(function (item) {
          return {
            kind: "text",
            types: new Set(Object.keys(item)),
            getText: function getText(type) {
              return Promise.resolve(item[type]);
            }
          };
        });
        var rect = this.currentDropTarget.element.getBoundingClientRect();
        this.currentDropTarget.onDrop({
          type: "drop",
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2,
          items: items,
          dropOperation: this.dropOperation
        }, item === null || item === void 0 ? void 0 : item.target);
      }
      this.end();
      (0, $fP8tg$announce)(this.stringFormatter.format("dropComplete"));
    }
  }, {
    key: "activate",
    value: function activate() {
      if (this.currentDropTarget && typeof this.currentDropTarget.onDropActivate === "function") {
        var rect = this.currentDropTarget.element.getBoundingClientRect();
        this.currentDropTarget.onDropActivate({
          type: "dropactivate",
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2
        });
      }
    }
  }]);
  function $67560de7c78cb232$var$DragSession(target, stringFormatter) {
    _classCallCheck(this, $67560de7c78cb232$var$DragSession);
    this.dragTarget = target;
    this.stringFormatter = stringFormatter;
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.cancelEvent = this.cancelEvent.bind(this);
    this.initialFocused = false;
  }
  return $67560de7c78cb232$var$DragSession;
}();
function $67560de7c78cb232$var$findValidDropTargets(options) {
  var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(options.items);
  return _toConsumableArray($67560de7c78cb232$var$dropTargets.values()).filter(function (target) {
    if (target.element.closest('[aria-hidden="true"]')) return false;
    if (typeof target.getDropOperation === "function") return target.getDropOperation(types, options.allowedDropOperations) !== "cancel";
    return true;
  });
}
var $865c2eb7c00a83f1$exports = {};
$865c2eb7c00a83f1$exports = {
  "ar-AE": $7dfcac1a0c98c789$exports,
  "bg-BG": $f311c26671219eca$exports,
  "cs-CZ": $1aa4ade186550f72$exports,
  "da-DK": $b6b0ea1b94a7633c$exports,
  "de-DE": $d10e4f47c744ad52$exports,
  "el-GR": $b3d2bb9abce688ab$exports,
  "en-US": $f9b46437e610cca1$exports,
  "es-ES": $204b5c01bd3acf26$exports,
  "et-EE": $110bdd83348ecbc0$exports,
  "fi-FI": $87d3ccd5e347c7cc$exports,
  "fr-FR": $a5de891427686596$exports,
  "he-IL": $ad7f4c66d85b4494$exports,
  "hr-HR": $4aa59f3c6a796cae$exports,
  "hu-HU": $d8d3646556c40586$exports,
  "it-IT": $982d558b45395246$exports,
  "ja-JP": $6a0cf387b9de036c$exports,
  "ko-KR": $a97fefa2956f4bcb$exports,
  "lt-LT": $5fb5837f94e1c150$exports,
  "lv-LV": $5b2e5709864cc922$exports,
  "nb-NO": $ee15bb8efb18cc69$exports,
  "nl-NL": $1daf2d4602e26ac4$exports,
  "pl-PL": $7115429b0f60511f$exports,
  "pt-BR": $5edd453ae5d4a8bc$exports,
  "pt-PT": $5f431994f708535e$exports,
  "ro-RO": $107b5e2e45e971f1$exports,
  "ru-RU": $d4b9c2f01c1892f7$exports,
  "sk-SK": $dbdc1942894e83e4$exports,
  "sl-SI": $fbaaaaebd547d998$exports,
  "sr-SP": $a0caa33f1e264489$exports,
  "sv-SE": $d576b66176f5c0ff$exports,
  "tr-TR": $0681f168c13d8f2a$exports,
  "uk-UA": $2bfbc1f42c1cf5a7$exports,
  "zh-CN": $d0f488d433b55b8a$exports,
  "zh-TW": $46168b0dce85301e$exports
};
var $8253ed7ece74b463$var$MESSAGES = {
  keyboard: {
    start: "dragDescriptionKeyboard",
    end: "endDragKeyboard"
  },
  touch: {
    start: "dragDescriptionTouch",
    end: "endDragTouch"
  },
  virtual: {
    start: "dragDescriptionVirtual",
    end: "endDragVirtual"
  }
};
function $8253ed7ece74b463$export$7941f8aafa4b6021(options) {
  var hasDragButton = options.hasDragButton;
  var stringFormatter = (0, $fP8tg$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($865c2eb7c00a83f1$exports)), "@react-aria/dnd");
  var state = (0, $fP8tg$useRef)({
    options: options,
    x: 0,
    y: 0
  }).current;
  state.options = options;
  var isDraggingRef = (0, $fP8tg$useRef)(false);
  var _ref4 = (0, $fP8tg$useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    isDragging = _ref5[0],
    setDraggingState = _ref5[1];
  var setDragging = function setDragging(isDragging) {
    isDraggingRef.current = isDragging;
    setDraggingState(isDragging);
  };
  var _ref6 = (0, $fP8tg$useGlobalListeners)(),
    addGlobalListener = _ref6.addGlobalListener,
    removeAllGlobalListeners = _ref6.removeAllGlobalListeners;
  var modalityOnPointerDown = (0, $fP8tg$useRef)(null);
  var onDragStart = function onDragStart(e) {
    var _options_preview;
    if (e.defaultPrevented) return;
    // Prevent the drag event from propagating to any parent draggables
    e.stopPropagation();
    // If this drag was initiated by a mobile screen reader (e.g. VoiceOver or TalkBack), enter virtual dragging mode.
    if (modalityOnPointerDown.current === "virtual") {
      e.preventDefault();
      startDragging(e.target);
      modalityOnPointerDown.current = null;
      return;
    }
    if (typeof options.onDragStart === "function") options.onDragStart({
      type: "dragstart",
      x: e.clientX,
      y: e.clientY
    });
    var items = options.getItems();
    (0, $7252cd45fc48c07c$export$f9c1490890ddd063)(e.dataTransfer, items);
    var allowed = (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).all;
    if (typeof options.getAllowedDropOperations === "function") {
      var allowedOperations = options.getAllowedDropOperations();
      allowed = (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).none;
      var _iterator11 = _createForOfIteratorHelper(allowedOperations),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var operation = _step11.value;
          allowed |= (0, $103790afe9474d1c$export$60b7b4bcf3903d8e)[operation] || (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).none;
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
    (0, $7252cd45fc48c07c$export$6539bc8c3a0a2d67)(allowed);
    e.dataTransfer.effectAllowed = (0, $103790afe9474d1c$export$dd0165308d8bff45)[allowed] || "none";
    // If there is a preview option, use it to render a custom preview image that will
    // appear under the pointer while dragging. If not, the element itself is dragged by the browser.
    if (typeof ((_options_preview = options.preview) === null || _options_preview === void 0 ? void 0 : _options_preview.current) === "function") options.preview.current(items, function (node) {
      // Compute the offset that the preview will appear under the mouse.
      // If possible, this is based on the point the user clicked on the target.
      // If the preview is much smaller, then just use the center point of the preview.
      var size = node.getBoundingClientRect();
      var rect = e.currentTarget.getBoundingClientRect();
      var x = e.clientX - rect.x;
      var y = e.clientY - rect.y;
      if (x > size.width || y > size.height) {
        x = size.width / 2;
        y = size.height / 2;
      }
      // Rounding height to an even number prevents blurry preview seen on some screens
      var height = 2 * Math.round(size.height / 2);
      node.style.height = "".concat(height, "px");
      e.dataTransfer.setDragImage(node, x, y);
    });
    // Enforce that drops are handled by useDrop.
    addGlobalListener(window, "drop", function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.warn("Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.");
    }, {
      once: true
    });
    state.x = e.clientX;
    state.y = e.clientY;
    // Wait a frame before we set dragging to true so that the browser has time to
    // render the preview image before we update the element that has been dragged.
    requestAnimationFrame(function () {
      setDragging(true);
    });
  };
  var onDrag = function onDrag(e) {
    // Prevent the drag event from propagating to any parent draggables
    e.stopPropagation();
    if (e.clientX === state.x && e.clientY === state.y) return;
    if (typeof options.onDragMove === "function") options.onDragMove({
      type: "dragmove",
      x: e.clientX,
      y: e.clientY
    });
    state.x = e.clientX;
    state.y = e.clientY;
  };
  var onDragEnd = function onDragEnd(e) {
    // Prevent the drag event from propagating to any parent draggables
    e.stopPropagation();
    if (typeof options.onDragEnd === "function") {
      var event = {
        type: "dragend",
        x: e.clientX,
        y: e.clientY,
        dropOperation: (0, $103790afe9474d1c$export$608ecc6f1b23c35d)[e.dataTransfer.dropEffect]
      };
      // Chrome Android always returns none as its dropEffect so we use the drop effect set in useDrop via
      // onDragEnter/onDragOver instead. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
      if (0, $7252cd45fc48c07c$export$8e6636520ac15722) event.dropOperation = (0, $103790afe9474d1c$export$608ecc6f1b23c35d)[(0, $7252cd45fc48c07c$export$8e6636520ac15722)];
      options.onDragEnd(event);
    }
    setDragging(false);
    removeAllGlobalListeners();
    (0, $7252cd45fc48c07c$export$6539bc8c3a0a2d67)((0, $103790afe9474d1c$export$60b7b4bcf3903d8e).none);
    (0, $7252cd45fc48c07c$export$64f52ed7349ddb84)(undefined);
  };
  // If the dragged element is removed from the DOM via onDrop, onDragEnd won't fire: https://bugzilla.mozilla.org/show_bug.cgi?id=460801
  // In this case, we need to manually call onDragEnd on cleanup
  // eslint-disable-next-line arrow-body-style
  (0, $fP8tg$useLayoutEffect)(function () {
    return function () {
      if (isDraggingRef.current) {
        if (typeof state.options.onDragEnd === "function") {
          var event = {
            type: "dragend",
            x: 0,
            y: 0,
            dropOperation: (0, $103790afe9474d1c$export$608ecc6f1b23c35d)[(0, $7252cd45fc48c07c$export$8e6636520ac15722) || "none"]
          };
          state.options.onDragEnd(event);
        }
        setDragging(false);
        (0, $7252cd45fc48c07c$export$6539bc8c3a0a2d67)((0, $103790afe9474d1c$export$60b7b4bcf3903d8e).none);
        (0, $7252cd45fc48c07c$export$64f52ed7349ddb84)(undefined);
      }
    };
  }, [state]);
  var onPress = function onPress(e) {
    if (e.pointerType !== "keyboard" && e.pointerType !== "virtual") return;
    startDragging(e.target);
  };
  var startDragging = function startDragging(target) {
    if (typeof state.options.onDragStart === "function") {
      var rect = target.getBoundingClientRect();
      state.options.onDragStart({
        type: "dragstart",
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2
      });
    }
    $67560de7c78cb232$export$549dbcf8649bf3b2({
      element: target,
      items: state.options.getItems(),
      allowedDropOperations: typeof state.options.getAllowedDropOperations === "function" ? state.options.getAllowedDropOperations() : ["move", "copy", "link"],
      onDragEnd: function onDragEnd(e) {
        setDragging(false);
        if (typeof state.options.onDragEnd === "function") state.options.onDragEnd(e);
      }
    }, stringFormatter);
    setDragging(true);
  };
  var modality = (0, $7252cd45fc48c07c$export$49bac5d6d4b352ea)();
  var message = !isDragging ? $8253ed7ece74b463$var$MESSAGES[modality].start : $8253ed7ece74b463$var$MESSAGES[modality].end;
  var descriptionProps = (0, $fP8tg$useDescription)(stringFormatter.format(message));
  var interactions;
  if (!hasDragButton)
    // If there's no separate button to trigger accessible drag and drop mode,
    // then add event handlers to the draggable element itself to start dragging.
    // For keyboard, we use the Enter key in a capturing listener to prevent other
    // events such as selection from also occurring. We attempt to infer whether a
    // pointer event (e.g. long press) came from a touch screen reader, and then initiate
    // dragging in the native onDragStart listener above.
    interactions = _objectSpread({}, descriptionProps, {
      onPointerDown: function onPointerDown(e) {
        modalityOnPointerDown.current = (0, $fP8tg$isVirtualPointerEvent)(e.nativeEvent) ? "virtual" : e.pointerType;
        // Try to detect virtual drag passthrough gestures.
        if (e.width < 1 && e.height < 1)
          // iOS VoiceOver.
          modalityOnPointerDown.current = "virtual";else {
          var rect = e.currentTarget.getBoundingClientRect();
          var offsetX = e.clientX - rect.x;
          var offsetY = e.clientY - rect.y;
          var centerX = rect.width / 2;
          var centerY = rect.height / 2;
          if (Math.abs(offsetX - centerX) <= 0.5 && Math.abs(offsetY - centerY) <= 0.5)
            // Android TalkBack.
            modalityOnPointerDown.current = "virtual";else modalityOnPointerDown.current = e.pointerType;
        }
      },
      onKeyDownCapture: function onKeyDownCapture(e) {
        if (e.target === e.currentTarget && e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      onKeyUpCapture: function onKeyUpCapture(e) {
        if (e.target === e.currentTarget && e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
          startDragging(e.target);
        }
      },
      onClick: function onClick(e) {
        // Handle NVDA/JAWS in browse mode, and touch screen readers. In this case, no keyboard events are fired.
        if ((0, $fP8tg$isVirtualClick)(e.nativeEvent) || modalityOnPointerDown.current === "virtual") {
          e.preventDefault();
          e.stopPropagation();
          startDragging(e.target);
        }
      }
    });
  return {
    dragProps: _objectSpread({}, interactions, {
      draggable: "true",
      onDragStart: onDragStart,
      onDrag: onDrag,
      onDragEnd: onDragEnd
    }),
    dragButtonProps: _objectSpread({}, descriptionProps, {
      onPress: onPress
    }),
    isDragging: isDragging
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $224594fe3e57ff1e$var$MESSAGES = {
  keyboard: "dropDescriptionKeyboard",
  touch: "dropDescriptionTouch",
  virtual: "dropDescriptionVirtual"
};
function $224594fe3e57ff1e$export$62447ad3d2ec7da6() {
  var stringFormatter = (0, $fP8tg$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($865c2eb7c00a83f1$exports)), "@react-aria/dnd");
  var modality = (0, $7252cd45fc48c07c$export$49bac5d6d4b352ea)();
  var dragSession = $67560de7c78cb232$export$418e185dd3f1b968();
  var descriptionProps = (0, $fP8tg$useDescription)(dragSession ? stringFormatter.format($224594fe3e57ff1e$var$MESSAGES[modality]) : "");
  return {
    dropProps: _objectSpread({}, descriptionProps, {
      // Mobile Safari does not properly bubble click events on elements except links or inputs
      // unless there is an onclick handler bound directly to the element itself. By adding this
      // handler, React will take care of adding that for us, and we are able to handle document
      // level click events in the DragManager.
      // See https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
      onClick: function onClick() {}
    })
  };
}
var $5c06e4929e123553$var$DROP_ACTIVATE_TIMEOUT = 800;
function $5c06e4929e123553$export$ccdee5eaf73cf661(options) {
  var hasDropButton = options.hasDropButton;
  var _ref7 = (0, $fP8tg$useState)(false),
    _ref8 = _slicedToArray(_ref7, 2),
    isDropTarget = _ref8[0],
    setDropTarget = _ref8[1];
  var state = (0, $fP8tg$useRef)({
    x: 0,
    y: 0,
    dragOverElements: new Set(),
    dropEffect: "none",
    allowedOperations: (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).all,
    dropActivateTimer: null
  }).current;
  var fireDropEnter = function fireDropEnter(e) {
    setDropTarget(true);
    if (typeof options.onDropEnter === "function") {
      var rect = e.currentTarget.getBoundingClientRect();
      options.onDropEnter({
        type: "dropenter",
        x: e.clientX - rect.x,
        y: e.clientY - rect.y
      });
    }
  };
  var fireDropExit = function fireDropExit(e) {
    setDropTarget(false);
    if (typeof options.onDropExit === "function") {
      var rect = e.currentTarget.getBoundingClientRect();
      options.onDropExit({
        type: "dropexit",
        x: e.clientX - rect.x,
        y: e.clientY - rect.y
      });
    }
  };
  var onDragOver = function onDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    var allowedOperations = $5c06e4929e123553$var$getAllowedOperations(e);
    if (e.clientX === state.x && e.clientY === state.y && allowedOperations === state.allowedOperations) {
      e.dataTransfer.dropEffect = state.dropEffect;
      return;
    }
    state.x = e.clientX;
    state.y = e.clientY;
    var prevDropEffect = state.dropEffect;
    // Update drop effect if allowed drop operations changed (e.g. user pressed modifier key).
    if (allowedOperations !== state.allowedOperations) {
      var allowedOps = $5c06e4929e123553$var$allowedOperationsToArray(allowedOperations);
      var dropOperation = allowedOps[0];
      if (typeof options.getDropOperation === "function") {
        var types = new (0, $7252cd45fc48c07c$export$7f04ce188c91447c)(e.dataTransfer);
        dropOperation = $5c06e4929e123553$var$getDropOperation(allowedOperations, options.getDropOperation(types, allowedOps));
      }
      state.dropEffect = (0, $103790afe9474d1c$export$5eacb0769d26d3b2)[dropOperation] || "none";
    }
    if (typeof options.getDropOperationForPoint === "function") {
      var _types3 = new (0, $7252cd45fc48c07c$export$7f04ce188c91447c)(e.dataTransfer);
      var rect = e.currentTarget.getBoundingClientRect();
      var _dropOperation = $5c06e4929e123553$var$getDropOperation(allowedOperations, options.getDropOperationForPoint(_types3, $5c06e4929e123553$var$allowedOperationsToArray(allowedOperations), state.x - rect.x, state.y - rect.y));
      state.dropEffect = (0, $103790afe9474d1c$export$5eacb0769d26d3b2)[_dropOperation] || "none";
    }
    state.allowedOperations = allowedOperations;
    e.dataTransfer.dropEffect = state.dropEffect;
    // If the drop operation changes, update state and fire events appropriately.
    if (state.dropEffect === "none" && prevDropEffect !== "none") fireDropExit(e);else if (state.dropEffect !== "none" && prevDropEffect === "none") fireDropEnter(e);
    if (typeof options.onDropMove === "function" && state.dropEffect !== "none") {
      var _rect2 = e.currentTarget.getBoundingClientRect();
      options.onDropMove({
        type: "dropmove",
        x: state.x - _rect2.x,
        y: state.y - _rect2.y
      });
    }
    clearTimeout(state.dropActivateTimer);
    if (typeof options.onDropActivate === "function" && state.dropEffect !== "none") {
      var _rect3 = e.currentTarget.getBoundingClientRect();
      state.dropActivateTimer = setTimeout(function () {
        options.onDropActivate({
          type: "dropactivate",
          x: state.x - _rect3.x,
          y: state.y - _rect3.y
        });
      }, $5c06e4929e123553$var$DROP_ACTIVATE_TIMEOUT);
    }
  };
  var onDragEnter = function onDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    state.dragOverElements.add(e.target);
    if (state.dragOverElements.size > 1) return;
    var allowedOperationsBits = $5c06e4929e123553$var$getAllowedOperations(e);
    var allowedOperations = $5c06e4929e123553$var$allowedOperationsToArray(allowedOperationsBits);
    var dropOperation = allowedOperations[0];
    if (typeof options.getDropOperation === "function") {
      var types = new (0, $7252cd45fc48c07c$export$7f04ce188c91447c)(e.dataTransfer);
      dropOperation = $5c06e4929e123553$var$getDropOperation(allowedOperationsBits, options.getDropOperation(types, allowedOperations));
    }
    if (typeof options.getDropOperationForPoint === "function") {
      var _types4 = new (0, $7252cd45fc48c07c$export$7f04ce188c91447c)(e.dataTransfer);
      var rect = e.currentTarget.getBoundingClientRect();
      dropOperation = $5c06e4929e123553$var$getDropOperation(allowedOperationsBits, options.getDropOperationForPoint(_types4, allowedOperations, e.clientX - rect.x, e.clientY - rect.y));
    }
    state.x = e.clientX;
    state.y = e.clientY;
    state.allowedOperations = allowedOperationsBits;
    state.dropEffect = (0, $103790afe9474d1c$export$5eacb0769d26d3b2)[dropOperation] || "none";
    e.dataTransfer.dropEffect = state.dropEffect;
    if (dropOperation !== "cancel") fireDropEnter(e);
  };
  var onDragLeave = function onDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    // We would use e.relatedTarget to detect if the drag is still inside the drop target,
    // but it is always null in WebKit. https://bugs.webkit.org/show_bug.cgi?id=66547
    // Instead, we track all of the targets of dragenter events in a set, and remove them
    // in dragleave. When the set becomes empty, we've left the drop target completely.
    // We must also remove any elements that are no longer in the DOM, because dragleave
    // events will never be fired for these. This can happen, for example, with drop
    // indicators between items, which disappear when the drop target changes.
    state.dragOverElements.delete(e.target);
    var _iterator12 = _createForOfIteratorHelper(state.dragOverElements),
      _step12;
    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var element = _step12.value;
        if (!e.currentTarget.contains(element)) state.dragOverElements.delete(element);
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
    if (state.dragOverElements.size > 0) return;
    if (state.dropEffect !== "none") fireDropExit(e);
    clearTimeout(state.dropActivateTimer);
  };
  var onDrop = function onDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    // Track drop effect in global state for Chrome Android. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
    // Android onDragEnd always returns "none" as its drop effect.
    (0, $7252cd45fc48c07c$export$64f52ed7349ddb84)(state.dropEffect);
    if (typeof options.onDrop === "function") {
      var dropOperation = (0, $103790afe9474d1c$export$608ecc6f1b23c35d)[state.dropEffect];
      var items = (0, $7252cd45fc48c07c$export$d9e760437831f8b3)(e.dataTransfer);
      var rect = e.currentTarget.getBoundingClientRect();
      var event = {
        type: "drop",
        x: e.clientX - rect.x,
        y: e.clientY - rect.y,
        items: items,
        dropOperation: dropOperation
      };
      options.onDrop(event);
    }
    var dndStateSnapshot = _objectSpread({}, (0, $7252cd45fc48c07c$export$6ca6700462636d0b));
    state.dragOverElements.clear();
    fireDropExit(e);
    clearTimeout(state.dropActivateTimer);
    // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
    // RSP collection and thus we don't need to preserve the global drop effect
    if (dndStateSnapshot.draggingCollectionRef == null) (0, $7252cd45fc48c07c$export$64f52ed7349ddb84)(undefined);else
      // Otherwise we need to preserve the global dnd state for onDragEnd's isInternal check.
      // At the moment fireDropExit may clear dropCollectionRef (i.e. useDroppableCollection's provided onDropExit, required to clear dropCollectionRef when exiting a valid drop target)
      (0, $7252cd45fc48c07c$export$6c10d32b362bfa5f)(dndStateSnapshot);
  };
  var _onDropEnter = (0, $fP8tg$useEffectEvent)(function (e) {
    if (typeof options.onDropEnter === "function") options.onDropEnter(e);
  });
  var _onDropExit = (0, $fP8tg$useEffectEvent)(function (e) {
    if (typeof options.onDropExit === "function") options.onDropExit(e);
  });
  var onDropActivate = (0, $fP8tg$useEffectEvent)(function (e) {
    if (typeof options.onDropActivate === "function") options.onDropActivate(e);
  });
  var onKeyboardDrop = (0, $fP8tg$useEffectEvent)(function (e) {
    if (typeof options.onDrop === "function") options.onDrop(e);
  });
  var getDropOperationKeyboard = (0, $fP8tg$useEffectEvent)(function (types, allowedOperations) {
    if (options.getDropOperation) return options.getDropOperation(types, allowedOperations);
    return allowedOperations[0];
  });
  var ref = options.ref;
  (0, $fP8tg$useLayoutEffect)(function () {
    return $67560de7c78cb232$export$c28d9fb4a54e471a({
      element: ref.current,
      getDropOperation: getDropOperationKeyboard,
      onDropEnter: function onDropEnter(e) {
        setDropTarget(true);
        _onDropEnter(e);
      },
      onDropExit: function onDropExit(e) {
        setDropTarget(false);
        _onDropExit(e);
      },
      onDrop: onKeyboardDrop,
      onDropActivate: onDropActivate
    });
  }, [ref, getDropOperationKeyboard, _onDropEnter, _onDropExit, onKeyboardDrop, onDropActivate]);
  var _ref9 = (0, $224594fe3e57ff1e$export$62447ad3d2ec7da6)(),
    dropProps = _ref9.dropProps;
  return {
    dropProps: _objectSpread({}, !hasDropButton && dropProps, {
      onDragEnter: onDragEnter,
      onDragOver: onDragOver,
      onDragLeave: onDragLeave,
      onDrop: onDrop
    }),
    dropButtonProps: _objectSpread({}, hasDropButton && dropProps),
    isDropTarget: isDropTarget
  };
}
function $5c06e4929e123553$var$getAllowedOperations(e) {
  var allowedOperations = (0, $103790afe9474d1c$export$9bbdfc78cf083e16)[e.dataTransfer.effectAllowed];
  // WebKit always sets effectAllowed to "copyMove" on macOS, and "all" on iOS, regardless of what was
  // set during the dragstart event: https://bugs.webkit.org/show_bug.cgi?id=178058
  //
  // Android Chrome also sets effectAllowed to "copyMove" in all cases: https://bugs.chromium.org/p/chromium/issues/detail?id=1359182
  //
  // If the drag started within the page, we can use a global variable to get the real allowed operations.
  // This needs to be intersected with the actual effectAllowed, which may have been filtered based on modifier keys.
  // Unfortunately, this means that link operations do not work at all in Safari.
  if (0, $7252cd45fc48c07c$export$f0130eb70b6347b8) allowedOperations &= (0, $7252cd45fc48c07c$export$f0130eb70b6347b8);
  // Chrome and Safari on macOS will automatically filter effectAllowed when pressing modifier keys,
  // allowing the user to switch between move, link, and copy operations. Firefox on macOS and all
  // Windows browsers do not do this, so do it ourselves instead. The exact keys are platform dependent.
  // https://ux.stackexchange.com/questions/83748/what-are-the-most-common-modifier-keys-for-dragging-objects-with-a-mouse
  //
  // Note that none of these modifiers are ever set in WebKit due to a bug: https://bugs.webkit.org/show_bug.cgi?id=77465
  // However, Safari does update effectAllowed correctly, so we can just rely on that.
  var allowedModifiers = (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).none;
  if ((0, $fP8tg$isMac)()) {
    if (e.altKey) allowedModifiers |= (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).copy;
    // Chrome and Safari both use the Control key for link, even though Finder uses Command + Option.
    // iPadOS doesn't support link operations and will not fire the drop event at all if dropEffect is set to link.
    // https://bugs.webkit.org/show_bug.cgi?id=244701
    if (e.ctrlKey && !(0, $fP8tg$isIPad)()) allowedModifiers |= (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).link;
    if (e.metaKey) allowedModifiers |= (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).move;
  } else {
    if (e.altKey) allowedModifiers |= (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).link;
    if (e.shiftKey) allowedModifiers |= (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).move;
    if (e.ctrlKey) allowedModifiers |= (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).copy;
  }
  if (allowedModifiers) return allowedOperations & allowedModifiers;
  return allowedOperations;
}
function $5c06e4929e123553$var$allowedOperationsToArray(allowedOperationsBits) {
  var allowedOperations = [];
  if (allowedOperationsBits & (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).move) allowedOperations.push("move");
  if (allowedOperationsBits & (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).copy) allowedOperations.push("copy");
  if (allowedOperationsBits & (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).link) allowedOperations.push("link");
  return allowedOperations;
}
function $5c06e4929e123553$var$getDropOperation(allowedOperations, operation) {
  var op = (0, $103790afe9474d1c$export$60b7b4bcf3903d8e)[operation];
  return allowedOperations & op ? operation : "cancel";
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $80d9daea3067eff3$var$AUTOSCROLL_AREA_SIZE = 20;
function $80d9daea3067eff3$export$6323452ca4533ed8(ref) {
  var scrollableRef = (0, $fP8tg$useRef)(null);
  var scrollableX = (0, $fP8tg$useRef)(true);
  var scrollableY = (0, $fP8tg$useRef)(true);
  (0, $fP8tg$useEffect)(function () {
    if (ref.current) {
      scrollableRef.current = (0, $fP8tg$isScrollable)(ref.current) ? ref.current : (0, $fP8tg$getScrollParent)(ref.current);
      var style = window.getComputedStyle(scrollableRef.current);
      scrollableX.current = /(auto|scroll)/.test(style.overflowX);
      scrollableY.current = /(auto|scroll)/.test(style.overflowY);
    }
  }, [ref]);
  var state = (0, $fP8tg$useRef)({
    timer: null,
    dx: 0,
    dy: 0
  }).current;
  (0, $fP8tg$useEffect)(function () {
    return function () {
      if (state.timer) {
        cancelAnimationFrame(state.timer);
        state.timer = null;
      }
    };
    // state will become a new object, so it's ok to use in the dependency array for unmount
  }, [state]);
  var scroll = (0, $fP8tg$useCallback)(function () {
    if (scrollableX.current) scrollableRef.current.scrollLeft += state.dx;
    if (scrollableY.current) scrollableRef.current.scrollTop += state.dy;
    if (state.timer) state.timer = requestAnimationFrame(scroll);
  }, [scrollableRef, state]);
  return {
    move: function move(x, y) {
      // Most browsers auto scroll natively, but WebKit on macOS does not (iOS does 🤷‍♂️).
      // https://bugs.webkit.org/show_bug.cgi?id=222636
      if (!(0, $fP8tg$isWebKit)() || (0, $fP8tg$isIOS)() || !scrollableRef.current) return;
      var box = scrollableRef.current.getBoundingClientRect();
      var left = $80d9daea3067eff3$var$AUTOSCROLL_AREA_SIZE;
      var top = $80d9daea3067eff3$var$AUTOSCROLL_AREA_SIZE;
      var bottom = box.height - $80d9daea3067eff3$var$AUTOSCROLL_AREA_SIZE;
      var right = box.width - $80d9daea3067eff3$var$AUTOSCROLL_AREA_SIZE;
      if (x < left || x > right || y < top || y > bottom) {
        if (x < left) state.dx = x - left;else if (x > right) state.dx = x - right;
        if (y < top) state.dy = y - top;else if (y > bottom) state.dy = y - bottom;
        if (!state.timer) state.timer = requestAnimationFrame(scroll);
      } else this.stop();
    },
    stop: function stop() {
      if (state.timer) {
        cancelAnimationFrame(state.timer);
        state.timer = null;
      }
    }
  };
}
var $4b52e4eff84e5217$var$DROP_POSITIONS = ["before", "on", "after"];
var $4b52e4eff84e5217$var$DROP_POSITIONS_RTL = ["after", "on", "before"];
function $4b52e4eff84e5217$export$f4e2f423c21f7b04(props, state, ref) {
  var localState = (0, $fP8tg$useRef)({
    props: props,
    state: state,
    nextTarget: null,
    dropOperation: null
  }).current;
  localState.props = props;
  localState.state = state;
  var defaultOnDrop = (0, $fP8tg$useCallback)( /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var _localState$props, onInsert, onRootDrop, onItemDrop, onReorder, _localState$props$acc, acceptedDragTypes, shouldAcceptItemDrop, _ref11, draggingKeys, isInternal, target, dropOperation, items, filteredItems;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _localState$props = localState.props, onInsert = _localState$props.onInsert, onRootDrop = _localState$props.onRootDrop, onItemDrop = _localState$props.onItemDrop, onReorder = _localState$props.onReorder, _localState$props$acc = _localState$props.acceptedDragTypes, acceptedDragTypes = _localState$props$acc === void 0 ? "all" : _localState$props$acc, shouldAcceptItemDrop = _localState$props.shouldAcceptItemDrop;
              _ref11 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b), draggingKeys = _ref11.draggingKeys;
              isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
              target = e.target, dropOperation = e.dropOperation, items = e.items;
              filteredItems = items;
              if (acceptedDragTypes !== "all" || shouldAcceptItemDrop) filteredItems = items.filter(function (item) {
                var itemTypes;
                if (item.kind === "directory") itemTypes = new Set([(0, $7252cd45fc48c07c$export$990fced5dfac2637)]);else itemTypes = item.kind === "file" ? new Set([item.type]) : item.types;
                if (acceptedDragTypes === "all" || acceptedDragTypes.some(function (type) {
                  return itemTypes.has(type);
                })) {
                  // If we are performing a on item drop, check if the item in question accepts the dropped item since the item may have heavier restrictions
                  // than the droppable collection itself
                  if (target.type === "item" && target.dropPosition === "on" && shouldAcceptItemDrop) return shouldAcceptItemDrop(target, itemTypes);
                  return true;
                }
                return false;
              });
              if (!(filteredItems.length > 0)) {
                _context2.next = 21;
                break;
              }
              if (!(target.type === "root" && onRootDrop)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 10;
              return onRootDrop({
                items: filteredItems,
                dropOperation: dropOperation
              });
            case 10:
              if (!(target.type === "item")) {
                _context2.next = 21;
                break;
              }
              if (!(target.dropPosition === "on" && onItemDrop)) {
                _context2.next = 14;
                break;
              }
              _context2.next = 14;
              return onItemDrop({
                items: filteredItems,
                dropOperation: dropOperation,
                isInternal: isInternal,
                target: target
              });
            case 14:
              if (!(target.dropPosition !== "on")) {
                _context2.next = 21;
                break;
              }
              if (!(!isInternal && onInsert)) {
                _context2.next = 18;
                break;
              }
              _context2.next = 18;
              return onInsert({
                items: filteredItems,
                dropOperation: dropOperation,
                target: target
              });
            case 18:
              if (!(isInternal && onReorder)) {
                _context2.next = 21;
                break;
              }
              _context2.next = 21;
              return onReorder({
                keys: draggingKeys,
                dropOperation: dropOperation,
                target: target
              });
            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref10.apply(this, arguments);
    };
  }(), [localState, ref]);
  var autoScroll = (0, $80d9daea3067eff3$export$6323452ca4533ed8)(ref);
  var _ref12 = (0, $5c06e4929e123553$export$ccdee5eaf73cf661)({
      ref: ref,
      onDropEnter: function onDropEnter() {
        state.setTarget(localState.nextTarget);
      },
      onDropMove: function onDropMove(e) {
        state.setTarget(localState.nextTarget);
        autoScroll.move(e.x, e.y);
      },
      getDropOperationForPoint: function getDropOperationForPoint(types, allowedOperations, x, y) {
        var _ref13 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
          draggingKeys = _ref13.draggingKeys,
          dropCollectionRef = _ref13.dropCollectionRef;
        var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
        var isValidDropTarget = function isValidDropTarget(target) {
          return state.getDropOperation({
            target: target,
            types: types,
            allowedOperations: allowedOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          }) !== "cancel";
        };
        var target = props.dropTargetDelegate.getDropTargetFromPoint(x, y, isValidDropTarget);
        if (!target) {
          localState.dropOperation = "cancel";
          localState.nextTarget = null;
          return "cancel";
        }
        localState.dropOperation = state.getDropOperation({
          target: target,
          types: types,
          allowedOperations: allowedOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
        // If the target doesn't accept the drop, see if the root accepts it instead.
        // If the target doesn't accept the drop, see if the root accepts it instead.
        if (localState.dropOperation === "cancel") {
          var rootTarget = {
            type: "root"
          };
          var dropOperation = state.getDropOperation({
            target: rootTarget,
            types: types,
            allowedOperations: allowedOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          });
          if (dropOperation !== "cancel") {
            target = rootTarget;
            localState.dropOperation = dropOperation;
          }
        }
        // Only set dropCollectionRef if there is a valid drop target since we cleanup dropCollectionRef in onDropExit
        // which only runs when leaving a valid drop target or if the dropEffect become none (mouse dnd only).
        // Only set dropCollectionRef if there is a valid drop target since we cleanup dropCollectionRef in onDropExit
        // which only runs when leaving a valid drop target or if the dropEffect become none (mouse dnd only).
        if (target && localState.dropOperation !== "cancel" && (ref === null || ref === void 0 ? void 0 : ref.current) !== (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current)) (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        localState.nextTarget = localState.dropOperation === "cancel" ? null : target;
        return localState.dropOperation;
      },
      onDropExit: function onDropExit() {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(undefined);
        state.setTarget(null);
        autoScroll.stop();
      },
      onDropActivate: function onDropActivate(e) {
        var _state_target, _state_target1;
        if (((_state_target = state.target) === null || _state_target === void 0 ? void 0 : _state_target.type) === "item" && ((_state_target1 = state.target) === null || _state_target1 === void 0 ? void 0 : _state_target1.dropPosition) === "on" && typeof props.onDropActivate === "function") props.onDropActivate({
          type: "dropactivate",
          x: e.x,
          y: e.y,
          target: state.target
        });
      },
      onDrop: function onDrop(e) {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        if (state.target) _onDrop(e, state.target);
        // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
        // RSP collection and thus we don't need to preserve the global DnD state for onDragEnd
        // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
        // RSP collection and thus we don't need to preserve the global DnD state for onDragEnd
        var _ref14 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
          draggingCollectionRef = _ref14.draggingCollectionRef;
        if (draggingCollectionRef == null) (0, $7252cd45fc48c07c$export$70936501603e6c57)();
      }
    }),
    dropProps = _ref12.dropProps;
  var droppingState = (0, $fP8tg$useRef)(null);
  var _onDrop = (0, $fP8tg$useCallback)(function (e, target) {
    var _state_collection_getItem;
    var state = localState.state; // Focus the collection.
    state.selectionManager.setFocused(true);
    // Save some state of the collection/selection before the drop occurs so we can compare later.
    var focusedKey = state.selectionManager.focusedKey;
    // If parent key was dragged, we want to use it instead (i.e. focus row instead of cell after dropping)
    if ((0, $7252cd45fc48c07c$export$6ca6700462636d0b).draggingKeys.has((_state_collection_getItem = state.collection.getItem(focusedKey)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.parentKey)) {
      focusedKey = state.collection.getItem(focusedKey).parentKey;
      state.selectionManager.setFocusedKey(focusedKey);
    }
    droppingState.current = {
      timeout: null,
      focusedKey: focusedKey,
      collection: state.collection,
      selectedKeys: state.selectionManager.selectedKeys
    };
    var onDropFn = localState.props.onDrop || defaultOnDrop;
    onDropFn({
      type: "drop",
      x: e.x,
      y: e.y,
      target: target,
      items: e.items,
      dropOperation: e.dropOperation
    });
    // Wait for a short time period after the onDrop is called to allow the data to be read asynchronously
    // and for React to re-render. If an insert occurs during this time, it will be selected/focused below.
    // If items are not "immediately" inserted by the onDrop handler, the application will need to handle
    // selecting and focusing those items themselves.
    droppingState.current.timeout = setTimeout(function () {
      // If focus didn't move already (e.g. due to an insert), and the user dropped on an item,
      // focus that item and show the focus ring to give the user feedback that the drop occurred.
      // Also show the focus ring if the focused key is not selected, e.g. in case of a reorder.
      var state = localState.state;
      if (target.type === "item" && target.dropPosition === "on" && state.collection.getItem(target.key) != null) {
        state.selectionManager.setFocusedKey(target.key);
        state.selectionManager.setFocused(true);
        (0, $fP8tg$setInteractionModality)("keyboard");
      } else if (!state.selectionManager.isSelected(focusedKey)) (0, $fP8tg$setInteractionModality)("keyboard");
      droppingState.current = null;
    }, 50);
  }, [localState, defaultOnDrop]);
  // eslint-disable-next-line arrow-body-style
  (0, $fP8tg$useEffect)(function () {
    return function () {
      if (droppingState.current) clearTimeout(droppingState.current.timeout);
    };
  }, []);
  (0, $fP8tg$useLayoutEffect)(function () {
    // If an insert occurs during a drop, we want to immediately select these items to give
    // feedback to the user that a drop occurred. Only do this if the selection didn't change
    // since the drop started so we don't override if the user or application did something.
    if (droppingState.current && state.selectionManager.isFocused && state.collection.size > droppingState.current.collection.size && state.selectionManager.isSelectionEqual(droppingState.current.selectedKeys)) {
      var newKeys = new Set();
      var _iterator13 = _createForOfIteratorHelper(state.collection.getKeys()),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var key = _step13.value;
          if (!droppingState.current.collection.getItem(key)) newKeys.add(key);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      state.selectionManager.setSelectedKeys(newKeys);
      // If the focused item didn't change since the drop occurred, also focus the first
      // inserted item. If selection is disabled, then also show the focus ring so there
      // is some indication that items were added.
      if (state.selectionManager.focusedKey === droppingState.current.focusedKey) {
        var first = newKeys.keys().next().value;
        var item = state.collection.getItem(first);
        // If this is a cell, focus the parent row.
        if ((item === null || item === void 0 ? void 0 : item.type) === "cell") first = item.parentKey;
        state.selectionManager.setFocusedKey(first);
        if (state.selectionManager.selectionMode === "none") (0, $fP8tg$setInteractionModality)("keyboard");
      }
      droppingState.current = null;
    }
  });
  var _ref15 = (0, $fP8tg$useLocale)(),
    direction = _ref15.direction;
  (0, $fP8tg$useEffect)(function () {
    var getNextTarget = function getNextTarget(target) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var horizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!target) return {
        type: "root"
      };
      var keyboardDelegate = localState.props.keyboardDelegate;
      var nextKey;
      if ((target === null || target === void 0 ? void 0 : target.type) === "item") nextKey = horizontal ? keyboardDelegate.getKeyRightOf(target.key) : keyboardDelegate.getKeyBelow(target.key);else nextKey = horizontal && direction === "rtl" ? keyboardDelegate.getLastKey() : keyboardDelegate.getFirstKey();
      var dropPositions = horizontal && direction === "rtl" ? $4b52e4eff84e5217$var$DROP_POSITIONS_RTL : $4b52e4eff84e5217$var$DROP_POSITIONS;
      var dropPosition = dropPositions[0];
      if (target.type === "item") {
        // If the the keyboard delegate returned the next key in the collection,
        // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
        // jump to the same drop position in the new key.
        var nextCollectionKey = horizontal && direction === "rtl" ? localState.state.collection.getKeyBefore(target.key) : localState.state.collection.getKeyAfter(target.key);
        if (nextKey == null || nextKey === nextCollectionKey) {
          var positionIndex = dropPositions.indexOf(target.dropPosition);
          var nextDropPosition = dropPositions[positionIndex + 1];
          if (positionIndex < dropPositions.length - 1 && !(nextDropPosition === dropPositions[2] && nextKey != null)) return {
            type: "item",
            key: target.key,
            dropPosition: nextDropPosition
          };
          // If the last drop position was 'after', then 'before' on the next key is equivalent.
          // Switch to 'on' instead.
          if (target.dropPosition === dropPositions[2]) dropPosition = "on";
        } else dropPosition = target.dropPosition;
      }
      if (nextKey == null) {
        if (wrap) return {
          type: "root"
        };
        return null;
      }
      return {
        type: "item",
        key: nextKey,
        dropPosition: dropPosition
      };
    };
    var getPreviousTarget = function getPreviousTarget(target) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var horizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var keyboardDelegate = localState.props.keyboardDelegate;
      var nextKey;
      if ((target === null || target === void 0 ? void 0 : target.type) === "item") nextKey = horizontal ? keyboardDelegate.getKeyLeftOf(target.key) : keyboardDelegate.getKeyAbove(target.key);else nextKey = horizontal && direction === "rtl" ? keyboardDelegate.getFirstKey() : keyboardDelegate.getLastKey();
      var dropPositions = horizontal && direction === "rtl" ? $4b52e4eff84e5217$var$DROP_POSITIONS_RTL : $4b52e4eff84e5217$var$DROP_POSITIONS;
      var dropPosition = !target || target.type === "root" ? dropPositions[2] : "on";
      if ((target === null || target === void 0 ? void 0 : target.type) === "item") {
        // If the the keyboard delegate returned the previous key in the collection,
        // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
        // jump to the same drop position in the new key.
        var prevCollectionKey = horizontal && direction === "rtl" ? localState.state.collection.getKeyAfter(target.key) : localState.state.collection.getKeyBefore(target.key);
        if (nextKey == null || nextKey === prevCollectionKey) {
          var positionIndex = dropPositions.indexOf(target.dropPosition);
          var nextDropPosition = dropPositions[positionIndex - 1];
          if (positionIndex > 0 && nextDropPosition !== dropPositions[2]) return {
            type: "item",
            key: target.key,
            dropPosition: nextDropPosition
          };
          // If the last drop position was 'before', then 'after' on the previous key is equivalent.
          // Switch to 'on' instead.
          if (target.dropPosition === dropPositions[0]) dropPosition = "on";
        } else dropPosition = target.dropPosition;
      }
      if (nextKey == null) {
        if (wrap) return {
          type: "root"
        };
        return null;
      }
      return {
        type: "item",
        key: nextKey,
        dropPosition: dropPosition
      };
    };
    var nextValidTarget = function nextValidTarget(target, types, allowedDropOperations, getNextTarget) {
      var wrap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var seenRoot = 0;
      var operation;
      var _ref16 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
        draggingKeys = _ref16.draggingKeys;
      var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
      do {
        var nextTarget = getNextTarget(target, wrap);
        if (!nextTarget) return null;
        target = nextTarget;
        operation = localState.state.getDropOperation({
          target: nextTarget,
          types: types,
          allowedOperations: allowedDropOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
        if (target.type === "root") seenRoot++;
      } while (operation === "cancel" && !localState.state.isDropTarget(target) && seenRoot < 2);
      if (operation === "cancel") return null;
      return target;
    };
    return $67560de7c78cb232$export$c28d9fb4a54e471a({
      element: ref.current,
      getDropOperation: function getDropOperation(types, allowedOperations) {
        if (localState.state.target) {
          var _ref17 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
            draggingKeys = _ref17.draggingKeys;
          var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
          return localState.state.getDropOperation({
            target: localState.state.target,
            types: types,
            allowedOperations: allowedOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          });
        }
        // Check if any of the targets accept the drop.
        // TODO: should we have a faster way of doing this or e.g. for pagination?
        var target = nextValidTarget(null, types, allowedOperations, getNextTarget);
        return target ? "move" : "cancel";
      },
      onDropEnter: function onDropEnter(e, drag) {
        var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(drag.items);
        var selectionManager = localState.state.selectionManager;
        var target;
        // Update the drop collection ref tracker for useDroppableItem's getDropOperation isInternal check
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        // When entering the droppable collection for the first time, the default drop target
        // is after the focused key.
        var key = selectionManager.focusedKey;
        var dropPosition = "after";
        // If the focused key is a cell, get the parent item instead.
        // For now, we assume that individual cells cannot be dropped on.
        var item = localState.state.collection.getItem(key);
        if ((item === null || item === void 0 ? void 0 : item.type) === "cell") key = item.parentKey;
        // If the focused item is also selected, the default drop target is after the last selected item.
        // But if the focused key is the first selected item, then default to before the first selected item.
        // This is to make reordering lists slightly easier. If you select top down, we assume you want to
        // move the items down. If you select bottom up, we assume you want to move the items up.
        if (selectionManager.isSelected(key)) {
          if (selectionManager.selectedKeys.size > 1 && selectionManager.firstSelectedKey === key) dropPosition = "before";else key = selectionManager.lastSelectedKey;
        }
        if (key != null) {
          target = {
            type: "item",
            key: key,
            dropPosition: dropPosition
          };
          var _ref18 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
            draggingKeys = _ref18.draggingKeys;
          var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
          var _nextValidTarget;
          // If the default target is not valid, find the next one that is.
          if (localState.state.getDropOperation({
            target: target,
            types: types,
            allowedOperations: drag.allowedDropOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          }) === "cancel") target = (_nextValidTarget = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
        }
        // If no focused key, then start from the root.
        if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
        localState.state.setTarget(target);
      },
      onDropExit: function onDropExit() {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(undefined);
        localState.state.setTarget(null);
      },
      onDropTargetEnter: function onDropTargetEnter(target) {
        localState.state.setTarget(target);
      },
      onDropActivate: function onDropActivate(e) {
        var _localState_state_target, _localState_state_target1;
        if (((_localState_state_target = localState.state.target) === null || _localState_state_target === void 0 ? void 0 : _localState_state_target.type) === "item" && ((_localState_state_target1 = localState.state.target) === null || _localState_state_target1 === void 0 ? void 0 : _localState_state_target1.dropPosition) === "on" && typeof localState.props.onDropActivate === "function") localState.props.onDropActivate({
          type: "dropactivate",
          x: e.x,
          y: e.y,
          target: localState.state.target
        });
      },
      onDrop: function onDrop(e, target) {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        if (localState.state.target) _onDrop(e, target || localState.state.target);
      },
      onKeyDown: function onKeyDown(e, drag) {
        var keyboardDelegate = localState.props.keyboardDelegate;
        var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(drag.items);
        switch (e.key) {
          case "ArrowDown":
            if (keyboardDelegate.getKeyBelow) {
              var target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getNextTarget);
              localState.state.setTarget(target);
            }
            break;
          case "ArrowUp":
            if (keyboardDelegate.getKeyAbove) {
              var _target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getPreviousTarget);
              localState.state.setTarget(_target);
            }
            break;
          case "ArrowLeft":
            if (keyboardDelegate.getKeyLeftOf) {
              var _target2 = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, function (target, wrap) {
                return getPreviousTarget(target, wrap, true);
              });
              localState.state.setTarget(_target2);
            }
            break;
          case "ArrowRight":
            if (keyboardDelegate.getKeyRightOf) {
              var _target3 = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, function (target, wrap) {
                return getNextTarget(target, wrap, true);
              });
              localState.state.setTarget(_target3);
            }
            break;
          case "Home":
            if (keyboardDelegate.getFirstKey) {
              var _target4 = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
              localState.state.setTarget(_target4);
            }
            break;
          case "End":
            if (keyboardDelegate.getLastKey) {
              var _target5 = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);
              localState.state.setTarget(_target5);
            }
            break;
          case "PageDown":
            if (keyboardDelegate.getKeyPageBelow) {
              var _target6 = localState.state.target;
              if (!_target6) _target6 = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);else {
                // If on the root, go to the item a page below the top. Otherwise a page below the current item.
                var nextKey = keyboardDelegate.getKeyPageBelow(_target6.type === "item" ? _target6.key : keyboardDelegate.getFirstKey());
                var dropPosition = _target6.type === "item" ? _target6.dropPosition : "after";
                // If there is no next key, or we are starting on the last key, jump to the last possible position.
                if (nextKey == null || _target6.type === "item" && _target6.key === keyboardDelegate.getLastKey()) {
                  nextKey = keyboardDelegate.getLastKey();
                  dropPosition = "after";
                }
                _target6 = {
                  type: "item",
                  key: nextKey,
                  dropPosition: dropPosition
                };
                // If the target does not accept the drop, find the next valid target.
                // If no next valid target, find the previous valid target.
                var _ref19 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
                  draggingCollectionRef = _ref19.draggingCollectionRef,
                  draggingKeys = _ref19.draggingKeys;
                var isInternal = (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) === (ref === null || ref === void 0 ? void 0 : ref.current);
                var operation = localState.state.getDropOperation({
                  target: _target6,
                  types: types,
                  allowedOperations: drag.allowedDropOperations,
                  isInternal: isInternal,
                  draggingKeys: draggingKeys
                });
                var _nextValidTarget;
                if (operation === "cancel") _target6 = (_nextValidTarget = nextValidTarget(_target6, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(_target6, types, drag.allowedDropOperations, getPreviousTarget, false);
              }
              localState.state.setTarget(_target6 !== null && _target6 !== void 0 ? _target6 : localState.state.target);
            }
            break;
          case "PageUp":
            {
              if (!keyboardDelegate.getKeyPageAbove) break;
              var _target7 = localState.state.target;
              if (!_target7) _target7 = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);else if (_target7.type === "item") {
                // If at the top already, switch to the root. Otherwise navigate a page up.
                if (_target7.key === keyboardDelegate.getFirstKey()) _target7 = {
                  type: "root"
                };else {
                  var _nextKey = keyboardDelegate.getKeyPageAbove(_target7.key);
                  var _dropPosition = _target7.dropPosition;
                  if (_nextKey == null) {
                    _nextKey = keyboardDelegate.getFirstKey();
                    _dropPosition = "before";
                  }
                  _target7 = {
                    type: "item",
                    key: _nextKey,
                    dropPosition: _dropPosition
                  };
                }
                // If the target does not accept the drop, find the previous valid target.
                // If no next valid target, find the next valid target.
                var _ref20 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
                  _draggingKeys = _ref20.draggingKeys;
                var _isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
                var _operation = localState.state.getDropOperation({
                  target: _target7,
                  types: types,
                  allowedOperations: drag.allowedDropOperations,
                  isInternal: _isInternal,
                  draggingKeys: _draggingKeys
                });
                var _nextValidTarget1;
                if (_operation === "cancel") _target7 = (_nextValidTarget1 = nextValidTarget(_target7, types, drag.allowedDropOperations, getPreviousTarget, false)) !== null && _nextValidTarget1 !== void 0 ? _nextValidTarget1 : nextValidTarget(_target7, types, drag.allowedDropOperations, getNextTarget, false);
              }
              localState.state.setTarget(_target7 !== null && _target7 !== void 0 ? _target7 : localState.state.target);
              break;
            }
        }
      }
    });
  }, [localState, ref, _onDrop, direction]);
  var id = (0, $fP8tg$useId)();
  (0, $7252cd45fc48c07c$export$dfdf5deeaf27473f).set(state, {
    id: id,
    ref: ref
  });
  return {
    collectionProps: (0, $fP8tg$mergeProps)(dropProps, {
      id: id,
      // Remove description from collection element. If dropping on the entire collection,
      // there should be a drop indicator that has this description, so no need to double announce.
      "aria-describedby": null
    })
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $bfaab576ce1c580e$export$f7b0c5d28b66b6a5(options, state, ref) {
  var _ref21 = (0, $224594fe3e57ff1e$export$62447ad3d2ec7da6)(),
    dropProps = _ref21.dropProps;
  var droppableCollectionRef = (0, $7252cd45fc48c07c$export$7e397efd01d3db27)(state);
  (0, $fP8tg$useEffect)(function () {
    if (ref.current) return $67560de7c78cb232$export$aef80212ac99c003({
      element: ref.current,
      target: options.target,
      getDropOperation: function getDropOperation(types, allowedOperations) {
        var _ref22 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
          draggingKeys = _ref22.draggingKeys;
        var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(droppableCollectionRef);
        return state.getDropOperation({
          target: options.target,
          types: types,
          allowedOperations: allowedOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
      }
    });
  }, [ref, options.target, state, droppableCollectionRef]);
  var dragSession = $67560de7c78cb232$export$418e185dd3f1b968();
  var _ref23 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
    draggingKeys = _ref23.draggingKeys;
  var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(droppableCollectionRef);
  var isValidDropTarget = dragSession && state.getDropOperation({
    target: options.target,
    types: (0, $7252cd45fc48c07c$export$e1d41611756c6326)(dragSession.dragTarget.items),
    allowedOperations: dragSession.dragTarget.allowedDropOperations,
    isInternal: isInternal,
    draggingKeys: draggingKeys
  }) !== "cancel";
  var isDropTarget = state.isDropTarget(options.target);
  (0, $fP8tg$useEffect)(function () {
    if (dragSession && isDropTarget && ref.current) ref.current.focus();
  }, [isDropTarget, dragSession, ref]);
  return {
    dropProps: _objectSpread({}, dropProps, {
      "aria-hidden": !dragSession || isValidDropTarget ? undefined : "true"
    }),
    isDropTarget: isDropTarget
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $ddf25448c71fc93a$export$8d0e41d2815afac5(props, state, ref) {
  var target = props.target;
  var collection = state.collection;
  var stringFormatter = (0, $fP8tg$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($865c2eb7c00a83f1$exports)), "@react-aria/dnd");
  var dragSession = $67560de7c78cb232$export$418e185dd3f1b968();
  var _ref24 = (0, $bfaab576ce1c580e$export$f7b0c5d28b66b6a5)(props, state, ref),
    dropProps = _ref24.dropProps;
  var id = (0, $fP8tg$useId)();
  var getText = function getText(key) {
    var _collection_getTextValue, _collection_getItem;
    var _collection_getTextValue1;
    return (_collection_getTextValue1 = (_collection_getTextValue = collection.getTextValue) === null || _collection_getTextValue === void 0 ? void 0 : _collection_getTextValue.call(collection, key)) !== null && _collection_getTextValue1 !== void 0 ? _collection_getTextValue1 : (_collection_getItem = collection.getItem(key)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue;
  };
  var label = "";
  var labelledBy;
  if (target.type === "root") {
    label = stringFormatter.format("dropOnRoot");
    labelledBy = "".concat(id, " ").concat((0, $7252cd45fc48c07c$export$3093291712f09a77)(state));
  } else if (target.dropPosition === "on") label = stringFormatter.format("dropOnItem", {
    itemText: getText(target.key)
  });else {
    var before;
    var after;
    if (collection.getFirstKey() === target.key && target.dropPosition === "before") before = null;else before = target.dropPosition === "before" ? collection.getKeyBefore(target.key) : target.key;
    if (collection.getLastKey() === target.key && target.dropPosition === "after") after = null;else after = target.dropPosition === "after" ? collection.getKeyAfter(target.key) : target.key;
    if (before && after) label = stringFormatter.format("insertBetween", {
      beforeItemText: getText(before),
      afterItemText: getText(after)
    });else if (before) label = stringFormatter.format("insertAfter", {
      itemText: getText(before)
    });else if (after) label = stringFormatter.format("insertBefore", {
      itemText: getText(after)
    });
  }
  var isDropTarget = state.isDropTarget(target);
  var ariaHidden = !dragSession ? "true" : dropProps["aria-hidden"];
  return {
    dropIndicatorProps: _objectSpread({}, dropProps, {
      id: id,
      "aria-roledescription": stringFormatter.format("dropIndicator"),
      "aria-label": label,
      "aria-labelledby": labelledBy,
      "aria-hidden": ariaHidden,
      tabIndex: -1
    }),
    isDropTarget: isDropTarget,
    // If aria-hidden, we are either not in a drag session or the drop target is invalid.
    // In that case, there's no need to render anything at all unless we need to show the indicator visually.
    // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
    isHidden: !isDropTarget && !!ariaHidden
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $fd98cf7cbf233429$var$MESSAGES = {
  keyboard: {
    selected: "dragSelectedKeyboard",
    notSelected: "dragDescriptionKeyboard"
  },
  touch: {
    selected: "dragSelectedLongPress",
    notSelected: "dragDescriptionLongPress"
  },
  virtual: {
    selected: "dragDescriptionVirtual",
    notSelected: "dragDescriptionVirtual"
  }
};
function $fd98cf7cbf233429$export$b35afafff42da2d9(props, state) {
  var stringFormatter = (0, $fP8tg$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($865c2eb7c00a83f1$exports)), "@react-aria/dnd");
  var isDisabled = state.selectionManager.isDisabled(props.key);
  var _ref25 = (0, $8253ed7ece74b463$export$7941f8aafa4b6021)({
      getItems: function getItems() {
        return state.getItems(props.key);
      },
      preview: state.preview,
      getAllowedDropOperations: state.getAllowedDropOperations,
      hasDragButton: props.hasDragButton,
      onDragStart: function onDragStart(e) {
        state.startDrag(props.key, e);
        // Track draggingKeys for useDroppableCollection's default onDrop handler and useDroppableCollectionState's default getDropOperation
        // Track draggingKeys for useDroppableCollection's default onDrop handler and useDroppableCollectionState's default getDropOperation
        (0, $7252cd45fc48c07c$export$72cb63bdda528276)(state.draggingKeys);
      },
      onDragMove: function onDragMove(e) {
        state.moveDrag(e);
      },
      onDragEnd: function onDragEnd(e) {
        var dropOperation = e.dropOperation;
        var isInternal = dropOperation === "cancel" ? false : (0, $7252cd45fc48c07c$export$78bf638634500fa5)();
        state.endDrag(_objectSpread({}, e, {
          keys: state.draggingKeys,
          isInternal: isInternal
        }));
        (0, $7252cd45fc48c07c$export$70936501603e6c57)();
      }
    }),
    dragProps = _ref25.dragProps,
    dragButtonProps = _ref25.dragButtonProps;
  var item = state.collection.getItem(props.key);
  var numKeysForDrag = state.getKeysForDrag(props.key).size;
  var isSelected = numKeysForDrag > 1 && state.selectionManager.isSelected(props.key);
  var dragButtonLabel;
  var description;
  // Override description to include selected item count.
  var modality = (0, $7252cd45fc48c07c$export$49bac5d6d4b352ea)();
  if (!props.hasDragButton && state.selectionManager.selectionMode !== "none") {
    var msg = $fd98cf7cbf233429$var$MESSAGES[modality][isSelected ? "selected" : "notSelected"];
    if (props.hasAction && modality === "keyboard") msg += "Alt";
    if (isSelected) description = stringFormatter.format(msg, {
      count: numKeysForDrag
    });else description = stringFormatter.format(msg);
    // Remove the onClick handler from useDrag. Long pressing will be required on touch devices,
    // and NVDA/JAWS are always in forms mode within collection components.
    delete dragProps.onClick;
  } else if (isSelected) dragButtonLabel = stringFormatter.format("dragSelectedItems", {
    count: numKeysForDrag
  });else {
    var _state_collection_getTextValue, _state_collection;
    var _state_collection_getTextValue1, _ref;
    var itemText = (_ref = (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, props.key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : item === null || item === void 0 ? void 0 : item.textValue) !== null && _ref !== void 0 ? _ref : "";
    dragButtonLabel = stringFormatter.format("dragItem", {
      itemText: itemText
    });
  }
  var descriptionProps = (0, $fP8tg$useDescription)(description);
  if (description) Object.assign(dragProps, descriptionProps);
  if (!props.hasDragButton && props.hasAction) {
    var onKeyDownCapture = dragProps.onKeyDownCapture,
      onKeyUpCapture = dragProps.onKeyUpCapture;
    if (modality === "touch")
      // Remove long press description if an action is present, because in that case long pressing selects the item.
      delete dragProps["aria-describedby"];
    // Require Alt key if there is a conflicting action.
    dragProps.onKeyDownCapture = function (e) {
      if (e.altKey) onKeyDownCapture(e);
    };
    dragProps.onKeyUpCapture = function (e) {
      if (e.altKey) onKeyUpCapture(e);
    };
  }
  return {
    dragProps: isDisabled ? {} : dragProps,
    dragButtonProps: _objectSpread({}, dragButtonProps, {
      isDisabled: isDisabled,
      "aria-label": dragButtonLabel
    })
  };
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $4ac1fdc3a0fcd564$export$2962a7984b2f0a80(props, state, ref) {
  // Update global DnD state if this keys within this collection are dragged
  var _ref26 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
    draggingCollectionRef = _ref26.draggingCollectionRef;
  if (state.draggingKeys.size > 0 && (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) !== ref.current) (0, $7252cd45fc48c07c$export$f2be18a910c0caa6)(ref);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $9fcc7f0d70d084ee$var$globalEvents = new Map();
function $9fcc7f0d70d084ee$var$addGlobalEventListener(event, fn) {
  var eventData = $9fcc7f0d70d084ee$var$globalEvents.get(event);
  if (!eventData) {
    var handlers = new Set();
    var listener = function listener(e) {
      var _iterator14 = _createForOfIteratorHelper(handlers),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var handler = _step14.value;
          handler(e);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    };
    eventData = {
      listener: listener,
      handlers: handlers
    };
    $9fcc7f0d70d084ee$var$globalEvents.set(event, eventData);
    document.addEventListener(event, listener);
  }
  eventData.handlers.add(fn);
  return function () {
    eventData.handlers.delete(fn);
    if (eventData.handlers.size === 0) {
      document.removeEventListener(event, eventData.listener);
      $9fcc7f0d70d084ee$var$globalEvents.delete(event);
    }
  };
}
function $9fcc7f0d70d084ee$export$2314ca2a3e892862(options) {
  var isFocusedRef = (0, $fP8tg$useRef)(false);
  var _ref27 = (0, $fP8tg$useFocus)({
      onFocusChange: function onFocusChange(isFocused) {
        isFocusedRef.current = isFocused;
      }
    }),
    focusProps = _ref27.focusProps;
  var onBeforeCopy = (0, $fP8tg$useEffectEvent)(function (e) {
    // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
    if (isFocusedRef.current && options.getItems) e.preventDefault();
  });
  var onCopy = (0, $fP8tg$useEffectEvent)(function (e) {
    var _options_onCopy;
    if (!isFocusedRef.current || !options.getItems) return;
    e.preventDefault();
    (0, $7252cd45fc48c07c$export$f9c1490890ddd063)(e.clipboardData, options.getItems());
    (_options_onCopy = options.onCopy) === null || _options_onCopy === void 0 ? void 0 : _options_onCopy.call(options);
  });
  var onBeforeCut = (0, $fP8tg$useEffectEvent)(function (e) {
    if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
  });
  var onCut = (0, $fP8tg$useEffectEvent)(function (e) {
    if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
    e.preventDefault();
    (0, $7252cd45fc48c07c$export$f9c1490890ddd063)(e.clipboardData, options.getItems());
    options.onCut();
  });
  var onBeforePaste = (0, $fP8tg$useEffectEvent)(function (e) {
    // Unfortunately, e.clipboardData.types is not available in this event so we always
    // have to enable the Paste menu item even if the type of data is unsupported.
    if (isFocusedRef.current && options.onPaste) e.preventDefault();
  });
  var onPaste = (0, $fP8tg$useEffectEvent)(function (e) {
    if (!isFocusedRef.current || !options.onPaste) return;
    e.preventDefault();
    var items = (0, $7252cd45fc48c07c$export$d9e760437831f8b3)(e.clipboardData);
    options.onPaste(items);
  });
  (0, $fP8tg$useEffect)(function () {
    return (0, $fP8tg$chain)($9fcc7f0d70d084ee$var$addGlobalEventListener("beforecopy", onBeforeCopy), $9fcc7f0d70d084ee$var$addGlobalEventListener("copy", onCopy), $9fcc7f0d70d084ee$var$addGlobalEventListener("beforecut", onBeforeCut), $9fcc7f0d70d084ee$var$addGlobalEventListener("cut", onCut), $9fcc7f0d70d084ee$var$addGlobalEventListener("beforepaste", onBeforePaste), $9fcc7f0d70d084ee$var$addGlobalEventListener("paste", onPaste));
  }, [onBeforeCopy, onCopy, onBeforeCut, onCut, onBeforePaste, onPaste]);
  return {
    clipboardProps: focusProps
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $ad0e3f3d9c50e4ba$var$DragPreview(props, ref) {
  var render = props.children;
  var _ref28 = (0, $fP8tg$useState)(null),
    _ref29 = _slicedToArray(_ref28, 2),
    children = _ref29[0],
    setChildren = _ref29[1];
  var domRef = (0, $fP8tg$useRef)(null);
  (0, $fP8tg$useImperativeHandle)(ref, function () {
    return function (items, callback) {
      // This will be called during the onDragStart event by useDrag. We need to render the
      // preview synchronously before this event returns so we can call event.dataTransfer.setDragImage.
      (0, $fP8tg$flushSync)(function () {
        setChildren(render(items));
      });
      // Yield back to useDrag to set the drag image.
      callback(domRef.current);
      // Remove the preview from the DOM after a frame so the browser has time to paint.
      requestAnimationFrame(function () {
        setChildren(null);
      });
    };
  }, [render]);
  if (!children) return null;
  return /*#__PURE__*/(0, $fP8tg$react).createElement("div", {
    style: {
      zIndex: -100,
      position: "absolute",
      top: 0,
      left: -100000
    },
    ref: domRef
  }, children);
}
var $ad0e3f3d9c50e4ba$export$905ab40ac2179daa = /*#__PURE__*/(0, $fP8tg$react).forwardRef($ad0e3f3d9c50e4ba$var$DragPreview);
var $3ca85212bf8898e4$export$fbd65d14c79e28cc = /*#__PURE__*/function () {
  _createClass($3ca85212bf8898e4$export$fbd65d14c79e28cc, [{
    key: "getPrimaryStart",
    value: function getPrimaryStart(rect) {
      return this.orientation === "horizontal" ? rect.left : rect.top;
    }
  }, {
    key: "getPrimaryEnd",
    value: function getPrimaryEnd(rect) {
      return this.orientation === "horizontal" ? rect.right : rect.bottom;
    }
  }, {
    key: "getSecondaryStart",
    value: function getSecondaryStart(rect) {
      return this.orientation === "horizontal" ? rect.top : rect.left;
    }
  }, {
    key: "getSecondaryEnd",
    value: function getSecondaryEnd(rect) {
      return this.orientation === "horizontal" ? rect.bottom : rect.right;
    }
  }, {
    key: "getFlowStart",
    value: function getFlowStart(rect) {
      return this.layout === "stack" ? this.getPrimaryStart(rect) : this.getSecondaryStart(rect);
    }
  }, {
    key: "getFlowEnd",
    value: function getFlowEnd(rect) {
      return this.layout === "stack" ? this.getPrimaryEnd(rect) : this.getSecondaryEnd(rect);
    }
  }, {
    key: "getFlowSize",
    value: function getFlowSize(rect) {
      return this.getFlowEnd(rect) - this.getFlowStart(rect);
    }
  }, {
    key: "getDropTargetFromPoint",
    value: function getDropTargetFromPoint(x, y, isValidDropTarget) {
      var _this4 = this;
      if (this.collection.size === 0) return {
        type: "root"
      };
      var rect = this.ref.current.getBoundingClientRect();
      var primary = this.orientation === "horizontal" ? x : y;
      var secondary = this.orientation === "horizontal" ? y : x;
      primary += this.getPrimaryStart(rect);
      secondary += this.getSecondaryStart(rect);
      var flow = this.layout === "stack" ? primary : secondary;
      var isPrimaryRTL = this.orientation === "horizontal" && this.direction === "rtl";
      var isSecondaryRTL = this.layout === "grid" && this.orientation === "vertical" && this.direction === "rtl";
      var isFlowRTL = this.layout === "stack" ? isPrimaryRTL : isSecondaryRTL;
      var elements = this.ref.current.querySelectorAll("[data-key]");
      var elementMap = new Map();
      var _iterator15 = _createForOfIteratorHelper(elements),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _item = _step15.value;
          if (_item instanceof HTMLElement) elementMap.set(_item.dataset.key, _item);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      var items = _toConsumableArray(this.collection);
      var low = 0;
      var high = items.length;
      var _loop2 = function _loop2() {
        var mid = Math.floor((low + high) / 2);
        var item = items[mid];
        var element = elementMap.get(String(item.key));
        var rect = element.getBoundingClientRect();
        var update = function update(isGreater) {
          if (isGreater) low = mid + 1;else high = mid;
        };
        if (primary < _this4.getPrimaryStart(rect)) update(isPrimaryRTL);else if (primary > _this4.getPrimaryEnd(rect)) update(!isPrimaryRTL);else if (secondary < _this4.getSecondaryStart(rect)) update(isSecondaryRTL);else if (secondary > _this4.getSecondaryEnd(rect)) update(!isSecondaryRTL);else {
          var target = {
            type: "item",
            key: item.key,
            dropPosition: "on"
          };
          if (isValidDropTarget(target)) {
            // Otherwise, if dropping on the item is accepted, try the before/after positions if within 5px
            // of the start or end of the item.
            if (flow <= _this4.getFlowStart(rect) + 5 && isValidDropTarget(_objectSpread({}, target, {
              dropPosition: "before"
            }))) target.dropPosition = isFlowRTL ? "after" : "before";else if (flow >= _this4.getFlowEnd(rect) - 5 && isValidDropTarget(_objectSpread({}, target, {
              dropPosition: "after"
            }))) target.dropPosition = isFlowRTL ? "before" : "after";
          } else {
            // If dropping on the item isn't accepted, try the target before or after depending on the position.
            var _mid = _this4.getFlowStart(rect) + _this4.getFlowSize(rect) / 2;
            if (flow <= _mid && isValidDropTarget(_objectSpread({}, target, {
              dropPosition: "before"
            }))) target.dropPosition = isFlowRTL ? "after" : "before";else if (flow >= _mid && isValidDropTarget(_objectSpread({}, target, {
              dropPosition: "after"
            }))) target.dropPosition = isFlowRTL ? "before" : "after";
          }
          return {
            v: target
          };
        }
      };
      while (low < high) {
        var _ret = _loop2();
        if (typeof _ret === "object") return _ret.v;
      }
      var item = items[Math.min(low, items.length - 1)];
      var element = elementMap.get(String(item.key));
      rect = element.getBoundingClientRect();
      if (primary < this.getPrimaryStart(rect) || Math.abs(flow - this.getFlowStart(rect)) < Math.abs(flow - this.getFlowEnd(rect))) return {
        type: "item",
        key: item.key,
        dropPosition: isFlowRTL ? "after" : "before"
      };
      return {
        type: "item",
        key: item.key,
        dropPosition: isFlowRTL ? "before" : "after"
      };
    }
  }]);
  function $3ca85212bf8898e4$export$fbd65d14c79e28cc(collection, ref, options) {
    _classCallCheck(this, $3ca85212bf8898e4$export$fbd65d14c79e28cc);
    this.collection = collection;
    this.ref = ref;
    this.layout = (options === null || options === void 0 ? void 0 : options.layout) || "stack";
    this.orientation = (options === null || options === void 0 ? void 0 : options.orientation) || "vertical";
    this.direction = (options === null || options === void 0 ? void 0 : options.direction) || "ltr";
  }
  return $3ca85212bf8898e4$export$fbd65d14c79e28cc;
}();
export { $7252cd45fc48c07c$export$990fced5dfac2637 as DIRECTORY_DRAG_TYPE, $8253ed7ece74b463$export$7941f8aafa4b6021 as useDrag, $5c06e4929e123553$export$ccdee5eaf73cf661 as useDrop, $4b52e4eff84e5217$export$f4e2f423c21f7b04 as useDroppableCollection, $bfaab576ce1c580e$export$f7b0c5d28b66b6a5 as useDroppableItem, $ddf25448c71fc93a$export$8d0e41d2815afac5 as useDropIndicator, $fd98cf7cbf233429$export$b35afafff42da2d9 as useDraggableItem, $4ac1fdc3a0fcd564$export$2962a7984b2f0a80 as useDraggableCollection, $9fcc7f0d70d084ee$export$2314ca2a3e892862 as useClipboard, $ad0e3f3d9c50e4ba$export$905ab40ac2179daa as DragPreview, $3ca85212bf8898e4$export$fbd65d14c79e28cc as ListDropTargetDelegate, $67560de7c78cb232$export$403bc76cbf68cf60 as isVirtualDragging, $7252cd45fc48c07c$export$2b40a62bdbe6b2b0 as isDirectoryDropItem, $7252cd45fc48c07c$export$a144e1752ebe0aa as isFileDropItem, $7252cd45fc48c07c$export$97fd558bdc44bea1 as isTextDropItem };